// the emoji catalog, by category: each emoji with its unicode name, the
// comma-separated shortcodes it goes by, and 's' if it takes a skin tone
// modifier. Generated from unicode's emoji-test data.

export type EmojiEntry = [
  emoji: string,
  name: string,
  shortcodes?: string,
  tones?: string
];

export type EmojiCategory = { category: string; emojis: EmojiEntry[] };

export const EMOJI_CATALOG: EmojiCategory[] = [
  {
    category: 'Smileys & Emotion',
    emojis: [
      ['😀', 'grinning face', 'grinning'],
      ['😃', 'grinning face with big eyes', 'smiley'],
      ['😄', 'grinning face with smiling eyes', 'smile'],
      ['😁', 'beaming face with smiling eyes', 'grin'],
      ['😆', 'grinning squinting face', 'laughing,satisfied'],
      ['😅', 'grinning face with sweat', 'sweat_smile'],
      ['🤣', 'rolling on the floor laughing', 'rofl'],
      ['😂', 'face with tears of joy', 'joy'],
      ['🙂', 'slightly smiling face', 'slightly_smiling_face'],
      ['🙃', 'upside-down face', 'upside_down_face'],
      ['😉', 'winking face', 'wink'],
      ['😊', 'smiling face with smiling eyes', 'blush'],
      ['😇', 'smiling face with halo', 'innocent'],
      ['🥰', 'smiling face with hearts', 'smiling_face_with_three_hearts'],
      ['😍', 'smiling face with heart-eyes', 'heart_eyes'],
      ['🤩', 'star-struck', 'star_struck'],
      ['😘', 'face blowing a kiss', 'kissing_heart'],
      ['😗', 'kissing face', 'kissing'],
      ['☺️', 'smiling face'],
      ['😚', 'kissing face with closed eyes', 'kissing_closed_eyes'],
      ['😙', 'kissing face with smiling eyes', 'kissing_smiling_eyes'],
      ['🥲', 'smiling face with tear'],
      ['😋', 'face savoring food', 'yum'],
      ['😛', 'face with tongue', 'stuck_out_tongue'],
      ['😜', 'winking face with tongue', 'stuck_out_tongue_winking_eye'],
      ['🤪', 'zany face', 'zany_face'],
      ['😝', 'squinting face with tongue', 'stuck_out_tongue_closed_eyes'],
      ['🤑', 'money-mouth face', 'money_mouth_face'],
      ['🤗', 'hugging face', 'hugs'],
      ['🤭', 'face with hand over mouth', 'hand_over_mouth'],
      ['🤫', 'shushing face', 'shushing_face'],
      ['🤔', 'thinking face', 'thinking'],
      ['🤐', 'zipper-mouth face', 'zipper_mouth_face'],
      ['🤨', 'face with raised eyebrow', 'raised_eyebrow'],
      ['😐', 'neutral face', 'neutral_face'],
      ['😑', 'expressionless face', 'expressionless'],
      ['😶', 'face without mouth', 'no_mouth'],
      ['😶‍🌫️', 'face in clouds'],
      ['😏', 'smirking face', 'smirk'],
      ['😒', 'unamused face', 'unamused'],
      ['🙄', 'face with rolling eyes', 'roll_eyes'],
      ['😬', 'grimacing face', 'grimacing'],
      ['😮‍💨', 'face exhaling'],
      ['🤥', 'lying face', 'lying_face'],
      ['😌', 'relieved face', 'relieved'],
      ['😔', 'pensive face', 'pensive'],
      ['😪', 'sleepy face', 'sleepy'],
      ['🤤', 'drooling face', 'drooling_face'],
      ['😴', 'sleeping face', 'sleeping'],
      ['😷', 'face with medical mask', 'mask'],
      ['🤒', 'face with thermometer', 'face_with_thermometer'],
      ['🤕', 'face with head-bandage', 'face_with_head_bandage'],
      ['🤢', 'nauseated face', 'nauseated_face'],
      ['🤮', 'face vomiting', 'vomiting_face'],
      ['🤧', 'sneezing face', 'sneezing_face'],
      ['🥵', 'hot face', 'hot_face'],
      ['🥶', 'cold face', 'cold_face'],
      ['🥴', 'woozy face', 'woozy_face'],
      ['😵', 'knocked-out face', 'dizzy_face'],
      ['😵‍💫', 'face with spiral eyes'],
      ['🤯', 'exploding head', 'exploding_head'],
      ['🤠', 'cowboy hat face', 'cowboy_hat_face'],
      ['🥳', 'partying face', 'partying_face'],
      ['🥸', 'disguised face'],
      ['😎', 'smiling face with sunglasses', 'sunglasses'],
      ['🤓', 'nerd face', 'nerd_face'],
      ['🧐', 'face with monocle', 'monocle_face'],
      ['😕', 'confused face', 'confused'],
      ['😟', 'worried face', 'worried'],
      ['🙁', 'slightly frowning face', 'slightly_frowning_face'],
      ['☹️', 'frowning face'],
      ['😮', 'face with open mouth', 'open_mouth'],
      ['😯', 'hushed face', 'hushed'],
      ['😲', 'astonished face', 'astonished'],
      ['😳', 'flushed face', 'flushed'],
      ['🥺', 'pleading face', 'pleading_face'],
      ['😦', 'frowning face with open mouth', 'frowning'],
      ['😧', 'anguished face', 'anguished'],
      ['😨', 'fearful face', 'fearful'],
      ['😰', 'anxious face with sweat', 'cold_sweat'],
      ['😥', 'sad but relieved face', 'disappointed_relieved'],
      ['😢', 'crying face', 'cry'],
      ['😭', 'loudly crying face', 'sob'],
      ['😱', 'face screaming in fear', 'scream'],
      ['😖', 'confounded face', 'confounded'],
      ['😣', 'persevering face', 'persevere'],
      ['😞', 'disappointed face', 'disappointed'],
      ['😓', 'downcast face with sweat', 'sweat'],
      ['😩', 'weary face', 'weary'],
      ['😫', 'tired face', 'tired_face'],
      ['🥱', 'yawning face', 'yawning_face'],
      ['😤', 'face with steam from nose', 'triumph'],
      ['😡', 'pouting face', 'pout,rage'],
      ['😠', 'angry face', 'angry'],
      ['🤬', 'face with symbols on mouth', 'cursing_face'],
      ['😈', 'smiling face with horns', 'smiling_imp'],
      ['👿', 'angry face with horns', 'imp'],
      ['💀', 'skull', 'skull'],
      ['☠️', 'skull and crossbones'],
      ['💩', 'pile of poo', 'hankey,poop,shit'],
      ['🤡', 'clown face', 'clown_face'],
      ['👹', 'ogre', 'japanese_ogre'],
      ['👺', 'goblin', 'japanese_goblin'],
      ['👻', 'ghost', 'ghost'],
      ['👽', 'alien', 'alien'],
      ['👾', 'alien monster', 'space_invader'],
      ['🤖', 'robot', 'robot'],
      ['😺', 'grinning cat', 'smiley_cat'],
      ['😸', 'grinning cat with smiling eyes', 'smile_cat'],
      ['😹', 'cat with tears of joy', 'joy_cat'],
      ['😻', 'smiling cat with heart-eyes', 'heart_eyes_cat'],
      ['😼', 'cat with wry smile', 'smirk_cat'],
      ['😽', 'kissing cat', 'kissing_cat'],
      ['🙀', 'weary cat', 'scream_cat'],
      ['😿', 'crying cat', 'crying_cat_face'],
      ['😾', 'pouting cat', 'pouting_cat'],
      ['🙈', 'see-no-evil monkey', 'see_no_evil'],
      ['🙉', 'hear-no-evil monkey', 'hear_no_evil'],
      ['🙊', 'speak-no-evil monkey', 'speak_no_evil'],
      ['💋', 'kiss mark', 'kiss'],
      ['💌', 'love letter', 'love_letter'],
      ['💘', 'heart with arrow', 'cupid'],
      ['💝', 'heart with ribbon', 'gift_heart'],
      ['💖', 'sparkling heart', 'sparkling_heart'],
      ['💗', 'growing heart', 'heartpulse'],
      ['💓', 'beating heart', 'heartbeat'],
      ['💞', 'revolving hearts', 'revolving_hearts'],
      ['💕', 'two hearts', 'two_hearts'],
      ['💟', 'heart decoration', 'heart_decoration'],
      ['❣️', 'heart exclamation'],
      ['💔', 'broken heart', 'broken_heart'],
      ['❤️‍🔥', 'heart on fire'],
      ['❤️‍🩹', 'mending heart'],
      ['❤️', 'red heart'],
      ['🧡', 'orange heart', 'orange_heart'],
      ['💛', 'yellow heart', 'yellow_heart'],
      ['💚', 'green heart', 'green_heart'],
      ['💙', 'blue heart', 'blue_heart'],
      ['💜', 'purple heart', 'purple_heart'],
      ['🤎', 'brown heart', 'brown_heart'],
      ['🖤', 'black heart', 'black_heart'],
      ['🤍', 'white heart', 'white_heart'],
      ['💯', 'hundred points', '100'],
      ['💢', 'anger symbol', 'anger'],
      ['💥', 'collision', 'boom,collision'],
      ['💫', 'dizzy', 'dizzy'],
      ['💦', 'sweat droplets', 'sweat_drops'],
      ['💨', 'dashing away', 'dash'],
      ['🕳️', 'hole'],
      ['💣', 'bomb', 'bomb'],
      ['💬', 'speech balloon', 'speech_balloon'],
      ['👁️‍🗨️', 'eye in speech bubble'],
      ['🗨️', 'left speech bubble'],
      ['🗯️', 'right anger bubble'],
      ['💭', 'thought balloon', 'thought_balloon'],
      ['💤', 'zzz', 'zzz']
    ]
  },
  {
    category: 'People & Body',
    emojis: [
      ['👋', 'waving hand', 'wave', 's'],
      ['🤚', 'raised back of hand', 'raised_back_of_hand', 's'],
      ['🖐️', 'hand with fingers splayed', '', 's'],
      ['✋', 'raised hand', 'hand,raised_hand', 's'],
      ['🖖', 'vulcan salute', 'vulcan_salute', 's'],
      ['👌', 'OK hand', 'ok_hand', 's'],
      ['🤌', 'pinched fingers', '', 's'],
      ['🤏', 'pinching hand', 'pinching_hand', 's'],
      ['✌️', 'victory hand', '', 's'],
      ['🤞', 'crossed fingers', 'crossed_fingers', 's'],
      ['🤟', 'love-you gesture', 'love_you_gesture', 's'],
      ['🤘', 'sign of the horns', 'metal', 's'],
      ['🤙', 'call me hand', 'call_me_hand', 's'],
      ['👈', 'backhand index pointing left', 'point_left', 's'],
      ['👉', 'backhand index pointing right', 'point_right', 's'],
      ['👆', 'backhand index pointing up', 'point_up_2', 's'],
      ['🖕', 'middle finger', 'fu,middle_finger', 's'],
      ['👇', 'backhand index pointing down', 'point_down', 's'],
      ['☝️', 'index pointing up', '', 's'],
      ['👍', 'thumbs up', '+1,thumbsup', 's'],
      ['👎', 'thumbs down', '-1,thumbsdown', 's'],
      ['✊', 'raised fist', 'fist,fist_raised', 's'],
      ['👊', 'oncoming fist', 'facepunch,fist_oncoming,punch', 's'],
      ['🤛', 'left-facing fist', 'fist_left', 's'],
      ['🤜', 'right-facing fist', 'fist_right', 's'],
      ['👏', 'clapping hands', 'clap', 's'],
      ['🙌', 'raising hands', 'raised_hands', 's'],
      ['👐', 'open hands', 'open_hands', 's'],
      ['🤲', 'palms up together', 'palms_up_together', 's'],
      ['🤝', 'handshake', 'handshake'],
      ['🙏', 'folded hands', 'pray', 's'],
      ['✍️', 'writing hand', '', 's'],
      ['💅', 'nail polish', 'nail_care', 's'],
      ['🤳', 'selfie', 'selfie', 's'],
      ['💪', 'flexed biceps', 'muscle', 's'],
      ['🦾', 'mechanical arm', 'mechanical_arm'],
      ['🦿', 'mechanical leg', 'mechanical_leg'],
      ['🦵', 'leg', 'leg', 's'],
      ['🦶', 'foot', 'foot', 's'],
      ['👂', 'ear', 'ear', 's'],
      ['🦻', 'ear with hearing aid', 'ear_with_hearing_aid', 's'],
      ['👃', 'nose', 'nose', 's'],
      ['🧠', 'brain', 'brain'],
      ['🫀', 'anatomical heart'],
      ['🫁', 'lungs'],
      ['🦷', 'tooth', 'tooth'],
      ['🦴', 'bone', 'bone'],
      ['👀', 'eyes', 'eyes'],
      ['👁️', 'eye'],
      ['👅', 'tongue', 'tongue'],
      ['👄', 'mouth', 'lips'],
      ['👶', 'baby', 'baby', 's'],
      ['🧒', 'child', 'child', 's'],
      ['👦', 'boy', 'boy', 's'],
      ['👧', 'girl', 'girl', 's'],
      ['🧑', 'person', 'adult', 's'],
      ['👱', 'person: blond hair', 'blond_haired_person', 's'],
      ['👨', 'man', 'man', 's'],
      ['🧔', 'person: beard', 'bearded_person', 's'],
      ['🧔‍♂️', 'man: beard', '', 's'],
      ['🧔‍♀️', 'woman: beard', '', 's'],
      ['👨‍🦰', 'man: red hair', 'red_haired_man', 's'],
      ['👨‍🦱', 'man: curly hair', 'curly_haired_man', 's'],
      ['👨‍🦳', 'man: white hair', 'white_haired_man', 's'],
      ['👨‍🦲', 'man: bald', 'bald_man', 's'],
      ['👩', 'woman', 'woman', 's'],
      ['👩‍🦰', 'woman: red hair', 'red_haired_woman', 's'],
      ['🧑‍🦰', 'person: red hair', 'person_red_hair', 's'],
      ['👩‍🦱', 'woman: curly hair', 'curly_haired_woman', 's'],
      ['🧑‍🦱', 'person: curly hair', 'person_curly_hair', 's'],
      ['👩‍🦳', 'woman: white hair', 'white_haired_woman', 's'],
      ['🧑‍🦳', 'person: white hair', 'person_white_hair', 's'],
      ['👩‍🦲', 'woman: bald', 'bald_woman', 's'],
      ['🧑‍🦲', 'person: bald', 'person_bald', 's'],
      ['👱‍♀️', 'woman: blond hair', '', 's'],
      ['👱‍♂️', 'man: blond hair', '', 's'],
      ['🧓', 'older person', 'older_adult', 's'],
      ['👴', 'old man', 'older_man', 's'],
      ['👵', 'old woman', 'older_woman', 's'],
      ['🙍', 'person frowning', 'frowning_person', 's'],
      ['🙍‍♂️', 'man frowning', '', 's'],
      ['🙍‍♀️', 'woman frowning', '', 's'],
      ['🙎', 'person pouting', 'pouting_face', 's'],
      ['🙎‍♂️', 'man pouting', '', 's'],
      ['🙎‍♀️', 'woman pouting', '', 's'],
      ['🙅', 'person gesturing NO', 'no_good', 's'],
      ['🙅‍♂️', 'man gesturing NO', '', 's'],
      ['🙅‍♀️', 'woman gesturing NO', '', 's'],
      ['🙆', 'person gesturing OK', 'ok_person', 's'],
      ['🙆‍♂️', 'man gesturing OK', '', 's'],
      ['🙆‍♀️', 'woman gesturing OK', '', 's'],
      [
        '💁',
        'person tipping hand',
        'information_desk_person,tipping_hand_person',
        's'
      ],
      ['💁‍♂️', 'man tipping hand', '', 's'],
      ['💁‍♀️', 'woman tipping hand', '', 's'],
      ['🙋', 'person raising hand', 'raising_hand', 's'],
      ['🙋‍♂️', 'man raising hand', '', 's'],
      ['🙋‍♀️', 'woman raising hand', '', 's'],
      ['🧏', 'deaf person', 'deaf_person', 's'],
      ['🧏‍♂️', 'deaf man', '', 's'],
      ['🧏‍♀️', 'deaf woman', '', 's'],
      ['🙇', 'person bowing', 'bow', 's'],
      ['🙇‍♂️', 'man bowing', '', 's'],
      ['🙇‍♀️', 'woman bowing', '', 's'],
      ['🤦', 'person facepalming', 'facepalm', 's'],
      ['🤦‍♂️', 'man facepalming', '', 's'],
      ['🤦‍♀️', 'woman facepalming', '', 's'],
      ['🤷', 'person shrugging', 'shrug', 's'],
      ['🤷‍♂️', 'man shrugging', '', 's'],
      ['🤷‍♀️', 'woman shrugging', '', 's'],
      ['🧑‍⚕️', 'health worker', '', 's'],
      ['👨‍⚕️', 'man health worker', '', 's'],
      ['👩‍⚕️', 'woman health worker', '', 's'],
      ['🧑‍🎓', 'student', 'student', 's'],
      ['👨‍🎓', 'man student', 'man_student', 's'],
      ['👩‍🎓', 'woman student', 'woman_student', 's'],
      ['🧑‍🏫', 'teacher', 'teacher', 's'],
      ['👨‍🏫', 'man teacher', 'man_teacher', 's'],
      ['👩‍🏫', 'woman teacher', 'woman_teacher', 's'],
      ['🧑‍⚖️', 'judge', '', 's'],
      ['👨‍⚖️', 'man judge', '', 's'],
      ['👩‍⚖️', 'woman judge', '', 's'],
      ['🧑‍🌾', 'farmer', 'farmer', 's'],
      ['👨‍🌾', 'man farmer', 'man_farmer', 's'],
      ['👩‍🌾', 'woman farmer', 'woman_farmer', 's'],
      ['🧑‍🍳', 'cook', 'cook', 's'],
      ['👨‍🍳', 'man cook', 'man_cook', 's'],
      ['👩‍🍳', 'woman cook', 'woman_cook', 's'],
      ['🧑‍🔧', 'mechanic', 'mechanic', 's'],
      ['👨‍🔧', 'man mechanic', 'man_mechanic', 's'],
      ['👩‍🔧', 'woman mechanic', 'woman_mechanic', 's'],
      ['🧑‍🏭', 'factory worker', 'factory_worker', 's'],
      ['👨‍🏭', 'man factory worker', 'man_factory_worker', 's'],
      ['👩‍🏭', 'woman factory worker', 'woman_factory_worker', 's'],
      ['🧑‍💼', 'office worker', 'office_worker', 's'],
      ['👨‍💼', 'man office worker', 'man_office_worker', 's'],
      ['👩‍💼', 'woman office worker', 'woman_office_worker', 's'],
      ['🧑‍🔬', 'scientist', 'scientist', 's'],
      ['👨‍🔬', 'man scientist', 'man_scientist', 's'],
      ['👩‍🔬', 'woman scientist', 'woman_scientist', 's'],
      ['🧑‍💻', 'technologist', 'technologist', 's'],
      ['👨‍💻', 'man technologist', 'man_technologist', 's'],
      ['👩‍💻', 'woman technologist', 'woman_technologist', 's'],
      ['🧑‍🎤', 'singer', 'singer', 's'],
      ['👨‍🎤', 'man singer', 'man_singer', 's'],
      ['👩‍🎤', 'woman singer', 'woman_singer', 's'],
      ['🧑‍🎨', 'artist', 'artist', 's'],
      ['👨‍🎨', 'man artist', 'man_artist', 's'],
      ['👩‍🎨', 'woman artist', 'woman_artist', 's'],
      ['🧑‍✈️', 'pilot', '', 's'],
      ['👨‍✈️', 'man pilot', '', 's'],
      ['👩‍✈️', 'woman pilot', '', 's'],
      ['🧑‍🚀', 'astronaut', 'astronaut', 's'],
      ['👨‍🚀', 'man astronaut', 'man_astronaut', 's'],
      ['👩‍🚀', 'woman astronaut', 'woman_astronaut', 's'],
      ['🧑‍🚒', 'firefighter', 'firefighter', 's'],
      ['👨‍🚒', 'man firefighter', 'man_firefighter', 's'],
      ['👩‍🚒', 'woman firefighter', 'woman_firefighter', 's'],
      ['👮', 'police officer', 'cop,police_officer', 's'],
      ['👮‍♂️', 'man police officer', '', 's'],
      ['👮‍♀️', 'woman police officer', '', 's'],
      ['🕵️', 'detective', '', 's'],
      ['🕵️‍♂️', 'man detective', '', 's'],
      ['🕵️‍♀️', 'woman detective', '', 's'],
      ['💂', 'guard', 'guard', 's'],
      ['💂‍♂️', 'man guard', '', 's'],
      ['💂‍♀️', 'woman guard', '', 's'],
      ['🥷', 'ninja', '', 's'],
      ['👷', 'construction worker', 'construction_worker', 's'],
      ['👷‍♂️', 'man construction worker', '', 's'],
      ['👷‍♀️', 'woman construction worker', '', 's'],
      ['🤴', 'prince', 'prince', 's'],
      ['👸', 'princess', 'princess', 's'],
      ['👳', 'person wearing turban', 'person_with_turban', 's'],
      ['👳‍♂️', 'man wearing turban', '', 's'],
      ['👳‍♀️', 'woman wearing turban', '', 's'],
      ['👲', 'person with skullcap', 'man_with_gua_pi_mao', 's'],
      ['🧕', 'woman with headscarf', 'woman_with_headscarf', 's'],
      ['🤵', 'person in tuxedo', 'man_in_tuxedo', 's'],
      ['🤵‍♂️', 'man in tuxedo', '', 's'],
      ['🤵‍♀️', 'woman in tuxedo', '', 's'],
      ['👰', 'person with veil', 'bride_with_veil', 's'],
      ['👰‍♂️', 'man with veil', '', 's'],
      ['👰‍♀️', 'woman with veil', '', 's'],
      ['🤰', 'pregnant woman', 'pregnant_woman', 's'],
      ['🤱', 'breast-feeding', 'breast_feeding', 's'],
      ['👩‍🍼', 'woman feeding baby', '', 's'],
      ['👨‍🍼', 'man feeding baby', '', 's'],
      ['🧑‍🍼', 'person feeding baby', '', 's'],
      ['👼', 'baby angel', 'angel', 's'],
      ['🎅', 'Santa Claus', 'santa', 's'],
      ['🤶', 'Mrs. Claus', 'mrs_claus', 's'],
      ['🧑‍🎄', 'mx claus', '', 's'],
      ['🦸', 'superhero', 'superhero', 's'],
      ['🦸‍♂️', 'man superhero', '', 's'],
      ['🦸‍♀️', 'woman superhero', '', 's'],
      ['🦹', 'supervillain', 'supervillain', 's'],
      ['🦹‍♂️', 'man supervillain', '', 's'],
      ['🦹‍♀️', 'woman supervillain', '', 's'],
      ['🧙', 'mage', 'mage', 's'],
      ['🧙‍♂️', 'man mage', '', 's'],
      ['🧙‍♀️', 'woman mage', '', 's'],
      ['🧚', 'fairy', 'fairy', 's'],
      ['🧚‍♂️', 'man fairy', '', 's'],
      ['🧚‍♀️', 'woman fairy', '', 's'],
      ['🧛', 'vampire', 'vampire', 's'],
      ['🧛‍♂️', 'man vampire', '', 's'],
      ['🧛‍♀️', 'woman vampire', '', 's'],
      ['🧜', 'merperson', 'merperson', 's'],
      ['🧜‍♂️', 'merman', '', 's'],
      ['🧜‍♀️', 'mermaid', '', 's'],
      ['🧝', 'elf', 'elf', 's'],
      ['🧝‍♂️', 'man elf', '', 's'],
      ['🧝‍♀️', 'woman elf', '', 's'],
      ['🧞', 'genie', 'genie'],
      ['🧞‍♂️', 'man genie'],
      ['🧞‍♀️', 'woman genie'],
      ['🧟', 'zombie', 'zombie'],
      ['🧟‍♂️', 'man zombie'],
      ['🧟‍♀️', 'woman zombie'],
      ['💆', 'person getting massage', 'massage', 's'],
      ['💆‍♂️', 'man getting massage', '', 's'],
      ['💆‍♀️', 'woman getting massage', '', 's'],
      ['💇', 'person getting haircut', 'haircut', 's'],
      ['💇‍♂️', 'man getting haircut', '', 's'],
      ['💇‍♀️', 'woman getting haircut', '', 's'],
      ['🚶', 'person walking', 'walking', 's'],
      ['🚶‍♂️', 'man walking', '', 's'],
      ['🚶‍♀️', 'woman walking', '', 's'],
      ['🧍', 'person standing', 'standing_person', 's'],
      ['🧍‍♂️', 'man standing', '', 's'],
      ['🧍‍♀️', 'woman standing', '', 's'],
      ['🧎', 'person kneeling', 'kneeling_person', 's'],
      ['🧎‍♂️', 'man kneeling', '', 's'],
      ['🧎‍♀️', 'woman kneeling', '', 's'],
      ['🧑‍🦯', 'person with white cane', 'person_with_probing_cane', 's'],
      ['👨‍🦯', 'man with white cane', 'man_with_probing_cane', 's'],
      ['👩‍🦯', 'woman with white cane', 'woman_with_probing_cane', 's'],
      [
        '🧑‍🦼',
        'person in motorized wheelchair',
        'person_in_motorized_wheelchair',
        's'
      ],
      ['👨‍🦼', 'man in motorized wheelchair', 'man_in_motorized_wheelchair', 's'],
      [
        '👩‍🦼',
        'woman in motorized wheelchair',
        'woman_in_motorized_wheelchair',
        's'
      ],
      ['🧑‍🦽', 'person in manual wheelchair', 'person_in_manual_wheelchair', 's'],
      ['👨‍🦽', 'man in manual wheelchair', 'man_in_manual_wheelchair', 's'],
      ['👩‍🦽', 'woman in manual wheelchair', 'woman_in_manual_wheelchair', 's'],
      ['🏃', 'person running', 'runner,running', 's'],
      ['🏃‍♂️', 'man running', '', 's'],
      ['🏃‍♀️', 'woman running', '', 's'],
      ['💃', 'woman dancing', 'dancer,woman_dancing', 's'],
      ['🕺', 'man dancing', 'man_dancing', 's'],
      ['🕴️', 'person in suit levitating', '', 's'],
      ['👯', 'people with bunny ears', 'dancers'],
      ['👯‍♂️', 'men with bunny ears'],
      ['👯‍♀️', 'women with bunny ears'],
      ['🧖', 'person in steamy room', 'sauna_person', 's'],
      ['🧖‍♂️', 'man in steamy room', '', 's'],
      ['🧖‍♀️', 'woman in steamy room', '', 's'],
      ['🧗', 'person climbing', 'climbing', 's'],
      ['🧗‍♂️', 'man climbing', '', 's'],
      ['🧗‍♀️', 'woman climbing', '', 's'],
      ['🤺', 'person fencing', 'person_fencing'],
      ['🏇', 'horse racing', 'horse_racing', 's'],
      ['⛷️', 'skier'],
      ['🏂', 'snowboarder', 'snowboarder', 's'],
      ['🏌️', 'person golfing', '', 's'],
      ['🏌️‍♂️', 'man golfing', '', 's'],
      ['🏌️‍♀️', 'woman golfing', '', 's'],
      ['🏄', 'person surfing', 'surfer', 's'],
      ['🏄‍♂️', 'man surfing', '', 's'],
      ['🏄‍♀️', 'woman surfing', '', 's'],
      ['🚣', 'person rowing boat', 'rowboat', 's'],
      ['🚣‍♂️', 'man rowing boat', '', 's'],
      ['🚣‍♀️', 'woman rowing boat', '', 's'],
      ['🏊', 'person swimming', 'swimmer', 's'],
      ['🏊‍♂️', 'man swimming', '', 's'],
      ['🏊‍♀️', 'woman swimming', '', 's'],
      ['⛹️', 'person bouncing ball', '', 's'],
      ['⛹️‍♂️', 'man bouncing ball', '', 's'],
      ['⛹️‍♀️', 'woman bouncing ball', '', 's'],
      ['🏋️', 'person lifting weights', '', 's'],
      ['🏋️‍♂️', 'man lifting weights', '', 's'],
      ['🏋️‍♀️', 'woman lifting weights', '', 's'],
      ['🚴', 'person biking', 'bicyclist', 's'],
      ['🚴‍♂️', 'man biking', '', 's'],
      ['🚴‍♀️', 'woman biking', '', 's'],
      ['🚵', 'person mountain biking', 'mountain_bicyclist', 's'],
      ['🚵‍♂️', 'man mountain biking', '', 's'],
      ['🚵‍♀️', 'woman mountain biking', '', 's'],
      ['🤸', 'person cartwheeling', 'cartwheeling', 's'],
      ['🤸‍♂️', 'man cartwheeling', '', 's'],
      ['🤸‍♀️', 'woman cartwheeling', '', 's'],
      ['🤼', 'people wrestling', 'wrestling'],
      ['🤼‍♂️', 'men wrestling'],
      ['🤼‍♀️', 'women wrestling'],
      ['🤽', 'person playing water polo', 'water_polo', 's'],
      ['🤽‍♂️', 'man playing water polo', '', 's'],
      ['🤽‍♀️', 'woman playing water polo', '', 's'],
      ['🤾', 'person playing handball', 'handball_person', 's'],
      ['🤾‍♂️', 'man playing handball', '', 's'],
      ['🤾‍♀️', 'woman playing handball', '', 's'],
      ['🤹', 'person juggling', 'juggling_person', 's'],
      ['🤹‍♂️', 'man juggling', '', 's'],
      ['🤹‍♀️', 'woman juggling', '', 's'],
      ['🧘', 'person in lotus position', 'lotus_position', 's'],
      ['🧘‍♂️', 'man in lotus position', '', 's'],
      ['🧘‍♀️', 'woman in lotus position', '', 's'],
      ['🛀', 'person taking bath', 'bath', 's'],
      ['🛌', 'person in bed', 'sleeping_bed', 's'],
      ['🧑‍🤝‍🧑', 'people holding hands', 'people_holding_hands', 's'],
      ['👭', 'women holding hands', 'two_women_holding_hands', 's'],
      ['👫', 'woman and man holding hands', 'couple', 's'],
      ['👬', 'men holding hands', 'two_men_holding_hands', 's'],
      ['💏', 'kiss', 'couplekiss', 's'],
      ['👩‍❤️‍💋‍👨', 'kiss: woman, man', '', 's'],
      ['👨‍❤️‍💋‍👨', 'kiss: man, man', '', 's'],
      ['👩‍❤️‍💋‍👩', 'kiss: woman, woman', '', 's'],
      ['💑', 'couple with heart', 'couple_with_heart', 's'],
      ['👩‍❤️‍👨', 'couple with heart: woman, man', '', 's'],
      ['👨‍❤️‍👨', 'couple with heart: man, man', '', 's'],
      ['👩‍❤️‍👩', 'couple with heart: woman, woman', '', 's'],
      ['👪', 'family', 'family'],
      ['👨‍👩‍👦', 'family: man, woman, boy', 'family_man_woman_boy'],
      ['👨‍👩‍👧', 'family: man, woman, girl', 'family_man_woman_girl'],
      ['👨‍👩‍👧‍👦', 'family: man, woman, girl, boy', 'family_man_woman_girl_boy'],
      ['👨‍👩‍👦‍👦', 'family: man, woman, boy, boy', 'family_man_woman_boy_boy'],
      ['👨‍👩‍👧‍👧', 'family: man, woman, girl, girl', 'family_man_woman_girl_girl'],
      ['👨‍👨‍👦', 'family: man, man, boy', 'family_man_man_boy'],
      ['👨‍👨‍👧', 'family: man, man, girl', 'family_man_man_girl'],
      ['👨‍👨‍👧‍👦', 'family: man, man, girl, boy', 'family_man_man_girl_boy'],
      ['👨‍👨‍👦‍👦', 'family: man, man, boy, boy', 'family_man_man_boy_boy'],
      ['👨‍👨‍👧‍👧', 'family: man, man, girl, girl', 'family_man_man_girl_girl'],
      ['👩‍👩‍👦', 'family: woman, woman, boy', 'family_woman_woman_boy'],
      ['👩‍👩‍👧', 'family: woman, woman, girl', 'family_woman_woman_girl'],
      ['👩‍👩‍👧‍👦', 'family: woman, woman, girl, boy', 'family_woman_woman_girl_boy'],
      ['👩‍👩‍👦‍👦', 'family: woman, woman, boy, boy', 'family_woman_woman_boy_boy'],
      [
        '👩‍👩‍👧‍👧',
        'family: woman, woman, girl, girl',
        'family_woman_woman_girl_girl'
      ],
      ['👨‍👦', 'family: man, boy', 'family_man_boy'],
      ['👨‍👦‍👦', 'family: man, boy, boy', 'family_man_boy_boy'],
      ['👨‍👧', 'family: man, girl', 'family_man_girl'],
      ['👨‍👧‍👦', 'family: man, girl, boy', 'family_man_girl_boy'],
      ['👨‍👧‍👧', 'family: man, girl, girl', 'family_man_girl_girl'],
      ['👩‍👦', 'family: woman, boy', 'family_woman_boy'],
      ['👩‍👦‍👦', 'family: woman, boy, boy', 'family_woman_boy_boy'],
      ['👩‍👧', 'family: woman, girl', 'family_woman_girl'],
      ['👩‍👧‍👦', 'family: woman, girl, boy', 'family_woman_girl_boy'],
      ['👩‍👧‍👧', 'family: woman, girl, girl', 'family_woman_girl_girl'],
      ['🗣️', 'speaking head'],
      ['👤', 'bust in silhouette', 'bust_in_silhouette'],
      ['👥', 'busts in silhouette', 'busts_in_silhouette'],
      ['🫂', 'people hugging'],
      ['👣', 'footprints', 'footprints']
    ]
  },
  {
    category: 'Animals & Nature',
    emojis: [
      ['🐵', 'monkey face', 'monkey_face'],
      ['🐒', 'monkey', 'monkey'],
      ['🦍', 'gorilla', 'gorilla'],
      ['🦧', 'orangutan', 'orangutan'],
      ['🐶', 'dog face', 'dog'],
      ['🐕', 'dog', 'dog2'],
      ['🦮', 'guide dog', 'guide_dog'],
      ['🐕‍🦺', 'service dog', 'service_dog'],
      ['🐩', 'poodle', 'poodle'],
      ['🐺', 'wolf', 'wolf'],
      ['🦊', 'fox', 'fox_face'],
      ['🦝', 'raccoon', 'raccoon'],
      ['🐱', 'cat face', 'cat'],
      ['🐈', 'cat', 'cat2'],
      ['🐈‍⬛', 'black cat'],
      ['🦁', 'lion', 'lion'],
      ['🐯', 'tiger face', 'tiger'],
      ['🐅', 'tiger', 'tiger2'],
      ['🐆', 'leopard', 'leopard'],
      ['🐴', 'horse face', 'horse'],
      ['🐎', 'horse', 'racehorse'],
      ['🦄', 'unicorn', 'unicorn'],
      ['🦓', 'zebra', 'zebra'],
      ['🦌', 'deer', 'deer'],
      ['🦬', 'bison'],
      ['🐮', 'cow face', 'cow'],
      ['🐂', 'ox', 'ox'],
      ['🐃', 'water buffalo', 'water_buffalo'],
      ['🐄', 'cow', 'cow2'],
      ['🐷', 'pig face', 'pig'],
      ['🐖', 'pig', 'pig2'],
      ['🐗', 'boar', 'boar'],
      ['🐽', 'pig nose', 'pig_nose'],
      ['🐏', 'ram', 'ram'],
      ['🐑', 'ewe', 'sheep'],
      ['🐐', 'goat', 'goat'],
      ['🐪', 'camel', 'dromedary_camel'],
      ['🐫', 'two-hump camel', 'camel'],
      ['🦙', 'llama', 'llama'],
      ['🦒', 'giraffe', 'giraffe'],
      ['🐘', 'elephant', 'elephant'],
      ['🦣', 'mammoth'],
      ['🦏', 'rhinoceros', 'rhinoceros'],
      ['🦛', 'hippopotamus', 'hippopotamus'],
      ['🐭', 'mouse face', 'mouse'],
      ['🐁', 'mouse', 'mouse2'],
      ['🐀', 'rat', 'rat'],
      ['🐹', 'hamster', 'hamster'],
      ['🐰', 'rabbit face', 'rabbit'],
      ['🐇', 'rabbit', 'rabbit2'],
      ['🐿️', 'chipmunk'],
      ['🦫', 'beaver'],
      ['🦔', 'hedgehog', 'hedgehog'],
      ['🦇', 'bat', 'bat'],
      ['🐻', 'bear', 'bear'],
      ['🐻‍❄️', 'polar bear'],
      ['🐨', 'koala', 'koala'],
      ['🐼', 'panda', 'panda_face'],
      ['🦥', 'sloth', 'sloth'],
      ['🦦', 'otter', 'otter'],
      ['🦨', 'skunk', 'skunk'],
      ['🦘', 'kangaroo', 'kangaroo'],
      ['🦡', 'badger', 'badger'],
      ['🐾', 'paw prints', 'feet,paw_prints'],
      ['🦃', 'turkey', 'turkey'],
      ['🐔', 'chicken', 'chicken'],
      ['🐓', 'rooster', 'rooster'],
      ['🐣', 'hatching chick', 'hatching_chick'],
      ['🐤', 'baby chick', 'baby_chick'],
      ['🐥', 'front-facing baby chick', 'hatched_chick'],
      ['🐦', 'bird', 'bird'],
      ['🐧', 'penguin', 'penguin'],
      ['🕊️', 'dove'],
      ['🦅', 'eagle', 'eagle'],
      ['🦆', 'duck', 'duck'],
      ['🦢', 'swan', 'swan'],
      ['🦉', 'owl', 'owl'],
      ['🦤', 'dodo'],
      ['🪶', 'feather'],
      ['🦩', 'flamingo', 'flamingo'],
      ['🦚', 'peacock', 'peacock'],
      ['🦜', 'parrot', 'parrot'],
      ['🐸', 'frog', 'frog'],
      ['🐊', 'crocodile', 'crocodile'],
      ['🐢', 'turtle', 'turtle'],
      ['🦎', 'lizard', 'lizard'],
      ['🐍', 'snake', 'snake'],
      ['🐲', 'dragon face', 'dragon_face'],
      ['🐉', 'dragon', 'dragon'],
      ['🦕', 'sauropod', 'sauropod'],
      ['🦖', 'T-Rex', 't-rex'],
      ['🐳', 'spouting whale', 'whale'],
      ['🐋', 'whale', 'whale2'],
      ['🐬', 'dolphin', 'dolphin,flipper'],
      ['🦭', 'seal'],
      ['🐟', 'fish', 'fish'],
      ['🐠', 'tropical fish', 'tropical_fish'],
      ['🐡', 'blowfish', 'blowfish'],
      ['🦈', 'shark', 'shark'],
      ['🐙', 'octopus', 'octopus'],
      ['🐚', 'spiral shell', 'shell'],
      ['🐌', 'snail', 'snail'],
      ['🦋', 'butterfly', 'butterfly'],
      ['🐛', 'bug', 'bug'],
      ['🐜', 'ant', 'ant'],
      ['🐝', 'honeybee', 'bee,honeybee'],
      ['🪲', 'beetle'],
      ['🐞', 'lady beetle', 'beetle'],
      ['🦗', 'cricket', 'cricket'],
      ['🪳', 'cockroach'],
      ['🕷️', 'spider'],
      ['🕸️', 'spider web'],
      ['🦂', 'scorpion', 'scorpion'],
      ['🦟', 'mosquito', 'mosquito'],
      ['🪰', 'fly'],
      ['🪱', 'worm'],
      ['🦠', 'microbe', 'microbe'],
      ['💐', 'bouquet', 'bouquet'],
      ['🌸', 'cherry blossom', 'cherry_blossom'],
      ['💮', 'white flower', 'white_flower'],
      ['🏵️', 'rosette'],
      ['🌹', 'rose', 'rose'],
      ['🥀', 'wilted flower', 'wilted_flower'],
      ['🌺', 'hibiscus', 'hibiscus'],
      ['🌻', 'sunflower', 'sunflower'],
      ['🌼', 'blossom', 'blossom'],
      ['🌷', 'tulip', 'tulip'],
      ['🌱', 'seedling', 'seedling'],
      ['🪴', 'potted plant'],
      ['🌲', 'evergreen tree', 'evergreen_tree'],
      ['🌳', 'deciduous tree', 'deciduous_tree'],
      ['🌴', 'palm tree', 'palm_tree'],
      ['🌵', 'cactus', 'cactus'],
      ['🌾', 'sheaf of rice', 'ear_of_rice'],
      ['🌿', 'herb', 'herb'],
      ['☘️', 'shamrock'],
      ['🍀', 'four leaf clover', 'four_leaf_clover'],
      ['🍁', 'maple leaf', 'maple_leaf'],
      ['🍂', 'fallen leaf', 'fallen_leaf'],
      ['🍃', 'leaf fluttering in wind', 'leaves']
    ]
  },
  {
    category: 'Food & Drink',
    emojis: [
      ['🍇', 'grapes', 'grapes'],
      ['🍈', 'melon', 'melon'],
      ['🍉', 'watermelon', 'watermelon'],
      ['🍊', 'tangerine', 'mandarin,orange,tangerine'],
      ['🍋', 'lemon', 'lemon'],
      ['🍌', 'banana', 'banana'],
      ['🍍', 'pineapple', 'pineapple'],
      ['🥭', 'mango', 'mango'],
      ['🍎', 'red apple', 'apple'],
      ['🍏', 'green apple', 'green_apple'],
      ['🍐', 'pear', 'pear'],
      ['🍑', 'peach', 'peach'],
      ['🍒', 'cherries', 'cherries'],
      ['🍓', 'strawberry', 'strawberry'],
      ['🫐', 'blueberries'],
      ['🥝', 'kiwi fruit', 'kiwi_fruit'],
      ['🍅', 'tomato', 'tomato'],
      ['🫒', 'olive'],
      ['🥥', 'coconut', 'coconut'],
      ['🥑', 'avocado', 'avocado'],
      ['🍆', 'eggplant', 'eggplant'],
      ['🥔', 'potato', 'potato'],
      ['🥕', 'carrot', 'carrot'],
      ['🌽', 'ear of corn', 'corn'],
      ['🌶️', 'hot pepper'],
      ['🫑', 'bell pepper'],
      ['🥒', 'cucumber', 'cucumber'],
      ['🥬', 'leafy green', 'leafy_green'],
      ['🥦', 'broccoli', 'broccoli'],
      ['🧄', 'garlic', 'garlic'],
      ['🧅', 'onion', 'onion'],
      ['🍄', 'mushroom', 'mushroom'],
      ['🥜', 'peanuts', 'peanuts'],
      ['🌰', 'chestnut', 'chestnut'],
      ['🍞', 'bread', 'bread'],
      ['🥐', 'croissant', 'croissant'],
      ['🥖', 'baguette bread', 'baguette_bread'],
      ['🫓', 'flatbread'],
      ['🥨', 'pretzel', 'pretzel'],
      ['🥯', 'bagel', 'bagel'],
      ['🥞', 'pancakes', 'pancakes'],
      ['🧇', 'waffle', 'waffle'],
      ['🧀', 'cheese wedge', 'cheese'],
      ['🍖', 'meat on bone', 'meat_on_bone'],
      ['🍗', 'poultry leg', 'poultry_leg'],
      ['🥩', 'cut of meat', 'cut_of_meat'],
      ['🥓', 'bacon', 'bacon'],
      ['🍔', 'hamburger', 'hamburger'],
      ['🍟', 'french fries', 'fries'],
      ['🍕', 'pizza', 'pizza'],
      ['🌭', 'hot dog', 'hotdog'],
      ['🥪', 'sandwich', 'sandwich'],
      ['🌮', 'taco', 'taco'],
      ['🌯', 'burrito', 'burrito'],
      ['🫔', 'tamale'],
      ['🥙', 'stuffed flatbread', 'stuffed_flatbread'],
      ['🧆', 'falafel', 'falafel'],
      ['🥚', 'egg', 'egg'],
      ['🍳', 'cooking', 'fried_egg'],
      ['🥘', 'shallow pan of food', 'shallow_pan_of_food'],
      ['🍲', 'pot of food', 'stew'],
      ['🫕', 'fondue'],
      ['🥣', 'bowl with spoon', 'bowl_with_spoon'],
      ['🥗', 'green salad', 'green_salad'],
      ['🍿', 'popcorn', 'popcorn'],
      ['🧈', 'butter', 'butter'],
      ['🧂', 'salt', 'salt'],
      ['🥫', 'canned food', 'canned_food'],
      ['🍱', 'bento box', 'bento'],
      ['🍘', 'rice cracker', 'rice_cracker'],
      ['🍙', 'rice ball', 'rice_ball'],
      ['🍚', 'cooked rice', 'rice'],
      ['🍛', 'curry rice', 'curry'],
      ['🍜', 'steaming bowl', 'ramen'],
      ['🍝', 'spaghetti', 'spaghetti'],
      ['🍠', 'roasted sweet potato', 'sweet_potato'],
      ['🍢', 'oden', 'oden'],
      ['🍣', 'sushi', 'sushi'],
      ['🍤', 'fried shrimp', 'fried_shrimp'],
      ['🍥', 'fish cake with swirl', 'fish_cake'],
      ['🥮', 'moon cake', 'moon_cake'],
      ['🍡', 'dango', 'dango'],
      ['🥟', 'dumpling', 'dumpling'],
      ['🥠', 'fortune cookie', 'fortune_cookie'],
      ['🥡', 'takeout box', 'takeout_box'],
      ['🦀', 'crab', 'crab'],
      ['🦞', 'lobster', 'lobster'],
      ['🦐', 'shrimp', 'shrimp'],
      ['🦑', 'squid', 'squid'],
      ['🦪', 'oyster', 'oyster'],
      ['🍦', 'soft ice cream', 'icecream'],
      ['🍧', 'shaved ice', 'shaved_ice'],
      ['🍨', 'ice cream', 'ice_cream'],
      ['🍩', 'doughnut', 'doughnut'],
      ['🍪', 'cookie', 'cookie'],
      ['🎂', 'birthday cake', 'birthday'],
      ['🍰', 'shortcake', 'cake'],
      ['🧁', 'cupcake', 'cupcake'],
      ['🥧', 'pie', 'pie'],
      ['🍫', 'chocolate bar', 'chocolate_bar'],
      ['🍬', 'candy', 'candy'],
      ['🍭', 'lollipop', 'lollipop'],
      ['🍮', 'custard', 'custard'],
      ['🍯', 'honey pot', 'honey_pot'],
      ['🍼', 'baby bottle', 'baby_bottle'],
      ['🥛', 'glass of milk', 'milk_glass'],
      ['☕', 'hot beverage', 'coffee'],
      ['🫖', 'teapot'],
      ['🍵', 'teacup without handle', 'tea'],
      ['🍶', 'sake', 'sake'],
      ['🍾', 'bottle with popping cork', 'champagne'],
      ['🍷', 'wine glass', 'wine_glass'],
      ['🍸', 'cocktail glass', 'cocktail'],
      ['🍹', 'tropical drink', 'tropical_drink'],
      ['🍺', 'beer mug', 'beer'],
      ['🍻', 'clinking beer mugs', 'beers'],
      ['🥂', 'clinking glasses', 'clinking_glasses'],
      ['🥃', 'tumbler glass', 'tumbler_glass'],
      ['🥤', 'cup with straw', 'cup_with_straw'],
      ['🧋', 'bubble tea'],
      ['🧃', 'beverage box', 'beverage_box'],
      ['🧉', 'mate', 'mate'],
      ['🧊', 'ice', 'ice_cube'],
      ['🥢', 'chopsticks', 'chopsticks'],
      ['🍽️', 'fork and knife with plate'],
      ['🍴', 'fork and knife', 'fork_and_knife'],
      ['🥄', 'spoon', 'spoon'],
      ['🔪', 'kitchen knife', 'hocho,knife'],
      ['🏺', 'amphora', 'amphora']
    ]
  },
  {
    category: 'Travel & Places',
    emojis: [
      ['🌍', 'globe showing Europe-Africa', 'earth_africa'],
      ['🌎', 'globe showing Americas', 'earth_americas'],
      ['🌏', 'globe showing Asia-Australia', 'earth_asia'],
      ['🌐', 'globe with meridians', 'globe_with_meridians'],
      ['🗺️', 'world map'],
      ['🗾', 'map of Japan', 'japan'],
      ['🧭', 'compass', 'compass'],
      ['🏔️', 'snow-capped mountain'],
      ['⛰️', 'mountain'],
      ['🌋', 'volcano', 'volcano'],
      ['🗻', 'mount fuji', 'mount_fuji'],
      ['🏕️', 'camping'],
      ['🏖️', 'beach with umbrella'],
      ['🏜️', 'desert'],
      ['🏝️', 'desert island'],
      ['🏞️', 'national park'],
      ['🏟️', 'stadium'],
      ['🏛️', 'classical building'],
      ['🏗️', 'building construction'],
      ['🧱', 'brick', 'bricks'],
      ['🪨', 'rock'],
      ['🪵', 'wood'],
      ['🛖', 'hut'],
      ['🏘️', 'houses'],
      ['🏚️', 'derelict house'],
      ['🏠', 'house', 'house'],
      ['🏡', 'house with garden', 'house_with_garden'],
      ['🏢', 'office building', 'office'],
      ['🏣', 'Japanese post office', 'post_office'],
      ['🏤', 'post office', 'european_post_office'],
      ['🏥', 'hospital', 'hospital'],
      ['🏦', 'bank', 'bank'],
      ['🏨', 'hotel', 'hotel'],
      ['🏩', 'love hotel', 'love_hotel'],
      ['🏪', 'convenience store', 'convenience_store'],
      ['🏫', 'school', 'school'],
      ['🏬', 'department store', 'department_store'],
      ['🏭', 'factory', 'factory'],
      ['🏯', 'Japanese castle', 'japanese_castle'],
      ['🏰', 'castle', 'european_castle'],
      ['💒', 'wedding', 'wedding'],
      ['🗼', 'Tokyo tower', 'tokyo_tower'],
      ['🗽', 'Statue of Liberty', 'statue_of_liberty'],
      ['⛪', 'church', 'church'],
      ['🕌', 'mosque', 'mosque'],
      ['🛕', 'hindu temple', 'hindu_temple'],
      ['🕍', 'synagogue', 'synagogue'],
      ['⛩️', 'shinto shrine'],
      ['🕋', 'kaaba', 'kaaba'],
      ['⛲', 'fountain', 'fountain'],
      ['⛺', 'tent', 'tent'],
      ['🌁', 'foggy', 'foggy'],
      ['🌃', 'night with stars', 'night_with_stars'],
      ['🏙️', 'cityscape'],
      ['🌄', 'sunrise over mountains', 'sunrise_over_mountains'],
      ['🌅', 'sunrise', 'sunrise'],
      ['🌆', 'cityscape at dusk', 'city_sunset'],
      ['🌇', 'sunset', 'city_sunrise'],
      ['🌉', 'bridge at night', 'bridge_at_night'],
      ['♨️', 'hot springs'],
      ['🎠', 'carousel horse', 'carousel_horse'],
      ['🎡', 'ferris wheel', 'ferris_wheel'],
      ['🎢', 'roller coaster', 'roller_coaster'],
      ['💈', 'barber pole', 'barber'],
      ['🎪', 'circus tent', 'circus_tent'],
      ['🚂', 'locomotive', 'steam_locomotive'],
      ['🚃', 'railway car', 'railway_car'],
      ['🚄', 'high-speed train', 'bullettrain_side'],
      ['🚅', 'bullet train', 'bullettrain_front'],
      ['🚆', 'train', 'train2'],
      ['🚇', 'metro', 'metro'],
      ['🚈', 'light rail', 'light_rail'],
      ['🚉', 'station', 'station'],
      ['🚊', 'tram', 'tram'],
      ['🚝', 'monorail', 'monorail'],
      ['🚞', 'mountain railway', 'mountain_railway'],
      ['🚋', 'tram car', 'train'],
      ['🚌', 'bus', 'bus'],
      ['🚍', 'oncoming bus', 'oncoming_bus'],
      ['🚎', 'trolleybus', 'trolleybus'],
      ['🚐', 'minibus', 'minibus'],
      ['🚑', 'ambulance', 'ambulance'],
      ['🚒', 'fire engine', 'fire_engine'],
      ['🚓', 'police car', 'police_car'],
      ['🚔', 'oncoming police car', 'oncoming_police_car'],
      ['🚕', 'taxi', 'taxi'],
      ['🚖', 'oncoming taxi', 'oncoming_taxi'],
      ['🚗', 'automobile', 'car,red_car'],
      ['🚘', 'oncoming automobile', 'oncoming_automobile'],
      ['🚙', 'sport utility vehicle', 'blue_car'],
      ['🛻', 'pickup truck'],
      ['🚚', 'delivery truck', 'truck'],
      ['🚛', 'articulated lorry', 'articulated_lorry'],
      ['🚜', 'tractor', 'tractor'],
      ['🏎️', 'racing car'],
      ['🏍️', 'motorcycle'],
      ['🛵', 'motor scooter', 'motor_scooter'],
      ['🦽', 'manual wheelchair', 'manual_wheelchair'],
      ['🦼', 'motorized wheelchair', 'motorized_wheelchair'],
      ['🛺', 'auto rickshaw', 'auto_rickshaw'],
      ['🚲', 'bicycle', 'bike'],
      ['🛴', 'kick scooter', 'kick_scooter'],
      ['🛹', 'skateboard', 'skateboard'],
      ['🛼', 'roller skate'],
      ['🚏', 'bus stop', 'busstop'],
      ['🛣️', 'motorway'],
      ['🛤️', 'railway track'],
      ['🛢️', 'oil drum'],
      ['⛽', 'fuel pump', 'fuelpump'],
      ['🚨', 'police car light', 'rotating_light'],
      ['🚥', 'horizontal traffic light', 'traffic_light'],
      ['🚦', 'vertical traffic light', 'vertical_traffic_light'],
      ['🛑', 'stop sign', 'stop_sign'],
      ['🚧', 'construction', 'construction'],
      ['⚓', 'anchor', 'anchor'],
      ['⛵', 'sailboat', 'boat,sailboat'],
      ['🛶', 'canoe', 'canoe'],
      ['🚤', 'speedboat', 'speedboat'],
      ['🛳️', 'passenger ship'],
      ['⛴️', 'ferry'],
      ['🛥️', 'motor boat'],
      ['🚢', 'ship', 'ship'],
      ['✈️', 'airplane'],
      ['🛩️', 'small airplane'],
      ['🛫', 'airplane departure', 'flight_departure'],
      ['🛬', 'airplane arrival', 'flight_arrival'],
      ['🪂', 'parachute', 'parachute'],
      ['💺', 'seat', 'seat'],
      ['🚁', 'helicopter', 'helicopter'],
      ['🚟', 'suspension railway', 'suspension_railway'],
      ['🚠', 'mountain cableway', 'mountain_cableway'],
      ['🚡', 'aerial tramway', 'aerial_tramway'],
      ['🛰️', 'satellite'],
      ['🚀', 'rocket', 'rocket'],
      ['🛸', 'flying saucer', 'flying_saucer'],
      ['🛎️', 'bellhop bell'],
      ['🧳', 'luggage', 'luggage'],
      ['⌛', 'hourglass done', 'hourglass'],
      ['⏳', 'hourglass not done', 'hourglass_flowing_sand'],
      ['⌚', 'watch', 'watch'],
      ['⏰', 'alarm clock', 'alarm_clock'],
      ['⏱️', 'stopwatch'],
      ['⏲️', 'timer clock'],
      ['🕰️', 'mantelpiece clock'],
      ['🕛', 'twelve o’clock', 'clock12'],
      ['🕧', 'twelve-thirty', 'clock1230'],
      ['🕐', 'one o’clock', 'clock1'],
      ['🕜', 'one-thirty', 'clock130'],
      ['🕑', 'two o’clock', 'clock2'],
      ['🕝', 'two-thirty', 'clock230'],
      ['🕒', 'three o’clock', 'clock3'],
      ['🕞', 'three-thirty', 'clock330'],
      ['🕓', 'four o’clock', 'clock4'],
      ['🕟', 'four-thirty', 'clock430'],
      ['🕔', 'five o’clock', 'clock5'],
      ['🕠', 'five-thirty', 'clock530'],
      ['🕕', 'six o’clock', 'clock6'],
      ['🕡', 'six-thirty', 'clock630'],
      ['🕖', 'seven o’clock', 'clock7'],
      ['🕢', 'seven-thirty', 'clock730'],
      ['🕗', 'eight o’clock', 'clock8'],
      ['🕣', 'eight-thirty', 'clock830'],
      ['🕘', 'nine o’clock', 'clock9'],
      ['🕤', 'nine-thirty', 'clock930'],
      ['🕙', 'ten o’clock', 'clock10'],
      ['🕥', 'ten-thirty', 'clock1030'],
      ['🕚', 'eleven o’clock', 'clock11'],
      ['🕦', 'eleven-thirty', 'clock1130'],
      ['🌑', 'new moon', 'new_moon'],
      ['🌒', 'waxing crescent moon', 'waxing_crescent_moon'],
      ['🌓', 'first quarter moon', 'first_quarter_moon'],
      ['🌔', 'waxing gibbous moon', 'moon,waxing_gibbous_moon'],
      ['🌕', 'full moon', 'full_moon'],
      ['🌖', 'waning gibbous moon', 'waning_gibbous_moon'],
      ['🌗', 'last quarter moon', 'last_quarter_moon'],
      ['🌘', 'waning crescent moon', 'waning_crescent_moon'],
      ['🌙', 'crescent moon', 'crescent_moon'],
      ['🌚', 'new moon face', 'new_moon_with_face'],
      ['🌛', 'first quarter moon face', 'first_quarter_moon_with_face'],
      ['🌜', 'last quarter moon face', 'last_quarter_moon_with_face'],
      ['🌡️', 'thermometer'],
      ['☀️', 'sun'],
      ['🌝', 'full moon face', 'full_moon_with_face'],
      ['🌞', 'sun with face', 'sun_with_face'],
      ['🪐', 'ringed planet', 'ringed_planet'],
      ['⭐', 'star', 'star'],
      ['🌟', 'glowing star', 'star2'],
      ['🌠', 'shooting star', 'stars'],
      ['🌌', 'milky way', 'milky_way'],
      ['☁️', 'cloud'],
      ['⛅', 'sun behind cloud', 'partly_sunny'],
      ['⛈️', 'cloud with lightning and rain'],
      ['🌤️', 'sun behind small cloud'],
      ['🌥️', 'sun behind large cloud'],
      ['🌦️', 'sun behind rain cloud'],
      ['🌧️', 'cloud with rain'],
      ['🌨️', 'cloud with snow'],
      ['🌩️', 'cloud with lightning'],
      ['🌪️', 'tornado'],
      ['🌫️', 'fog'],
      ['🌬️', 'wind face'],
      ['🌀', 'cyclone', 'cyclone'],
      ['🌈', 'rainbow', 'rainbow'],
      ['🌂', 'closed umbrella', 'closed_umbrella'],
      ['☂️', 'umbrella'],
      ['☔', 'umbrella with rain drops', 'umbrella'],
      ['⛱️', 'umbrella on ground'],
      ['⚡', 'high voltage', 'zap'],
      ['❄️', 'snowflake'],
      ['☃️', 'snowman'],
      ['⛄', 'snowman without snow', 'snowman'],
      ['☄️', 'comet'],
      ['🔥', 'fire', 'fire'],
      ['💧', 'droplet', 'droplet'],
      ['🌊', 'water wave', 'ocean']
    ]
  },
  {
    category: 'Activities',
    emojis: [
      ['🎃', 'jack-o-lantern', 'jack_o_lantern'],
      ['🎄', 'Christmas tree', 'christmas_tree'],
      ['🎆', 'fireworks', 'fireworks'],
      ['🎇', 'sparkler', 'sparkler'],
      ['🧨', 'firecracker', 'firecracker'],
      ['✨', 'sparkles', 'sparkles'],
      ['🎈', 'balloon', 'balloon'],
      ['🎉', 'party popper', 'tada'],
      ['🎊', 'confetti ball', 'confetti_ball'],
      ['🎋', 'tanabata tree', 'tanabata_tree'],
      ['🎍', 'pine decoration', 'bamboo'],
      ['🎎', 'Japanese dolls', 'dolls'],
      ['🎏', 'carp streamer', 'flags'],
      ['🎐', 'wind chime', 'wind_chime'],
      ['🎑', 'moon viewing ceremony', 'rice_scene'],
      ['🧧', 'red envelope', 'red_envelope'],
      ['🎀', 'ribbon', 'ribbon'],
      ['🎁', 'wrapped gift', 'gift'],
      ['🎗️', 'reminder ribbon'],
      ['🎟️', 'admission tickets'],
      ['🎫', 'ticket', 'ticket'],
      ['🎖️', 'military medal'],
      ['🏆', 'trophy', 'trophy'],
      ['🏅', 'sports medal', 'medal_sports'],
      ['🥇', '1st place medal', '1st_place_medal'],
      ['🥈', '2nd place medal', '2nd_place_medal'],
      ['🥉', '3rd place medal', '3rd_place_medal'],
      ['⚽', 'soccer ball', 'soccer'],
      ['⚾', 'baseball', 'baseball'],
      ['🥎', 'softball', 'softball'],
      ['🏀', 'basketball', 'basketball'],
      ['🏐', 'volleyball', 'volleyball'],
      ['🏈', 'american football', 'football'],
      ['🏉', 'rugby football', 'rugby_football'],
      ['🎾', 'tennis', 'tennis'],
      ['🥏', 'flying disc', 'flying_disc'],
      ['🎳', 'bowling', 'bowling'],
      ['🏏', 'cricket game', 'cricket_game'],
      ['🏑', 'field hockey', 'field_hockey'],
      ['🏒', 'ice hockey', 'ice_hockey'],
      ['🥍', 'lacrosse', 'lacrosse'],
      ['🏓', 'ping pong', 'ping_pong'],
      ['🏸', 'badminton', 'badminton'],
      ['🥊', 'boxing glove', 'boxing_glove'],
      ['🥋', 'martial arts uniform', 'martial_arts_uniform'],
      ['🥅', 'goal net', 'goal_net'],
      ['⛳', 'flag in hole', 'golf'],
      ['⛸️', 'ice skate'],
      ['🎣', 'fishing pole', 'fishing_pole_and_fish'],
      ['🤿', 'diving mask', 'diving_mask'],
      ['🎽', 'running shirt', 'running_shirt_with_sash'],
      ['🎿', 'skis', 'ski'],
      ['🛷', 'sled', 'sled'],
      ['🥌', 'curling stone', 'curling_stone'],
      ['🎯', 'bullseye', 'dart'],
      ['🪀', 'yo-yo', 'yo_yo'],
      ['🪁', 'kite', 'kite'],
      ['🎱', 'pool 8 ball', '8ball'],
      ['🔮', 'crystal ball', 'crystal_ball'],
      ['🪄', 'magic wand'],
      ['🧿', 'nazar amulet', 'nazar_amulet'],
      ['🎮', 'video game', 'video_game'],
      ['🕹️', 'joystick'],
      ['🎰', 'slot machine', 'slot_machine'],
      ['🎲', 'game die', 'game_die'],
      ['🧩', 'puzzle piece', 'jigsaw'],
      ['🧸', 'teddy bear', 'teddy_bear'],
      ['🪅', 'piñata'],
      ['🪆', 'nesting dolls'],
      ['♠️', 'spade suit'],
      ['♥️', 'heart suit'],
      ['♦️', 'diamond suit'],
      ['♣️', 'club suit'],
      ['♟️', 'chess pawn'],
      ['🃏', 'joker', 'black_joker'],
      ['🀄', 'mahjong red dragon', 'mahjong'],
      ['🎴', 'flower playing cards', 'flower_playing_cards'],
      ['🎭', 'performing arts', 'performing_arts'],
      ['🖼️', 'framed picture'],
      ['🎨', 'artist palette', 'art'],
      ['🧵', 'thread', 'thread'],
      ['🪡', 'sewing needle'],
      ['🧶', 'yarn', 'yarn'],
      ['🪢', 'knot']
    ]
  },
  {
    category: 'Objects',
    emojis: [
      ['👓', 'glasses', 'eyeglasses'],
      ['🕶️', 'sunglasses'],
      ['🥽', 'goggles', 'goggles'],
      ['🥼', 'lab coat', 'lab_coat'],
      ['🦺', 'safety vest', 'safety_vest'],
      ['👔', 'necktie', 'necktie'],
      ['👕', 't-shirt', 'shirt,tshirt'],
      ['👖', 'jeans', 'jeans'],
      ['🧣', 'scarf', 'scarf'],
      ['🧤', 'gloves', 'gloves'],
      ['🧥', 'coat', 'coat'],
      ['🧦', 'socks', 'socks'],
      ['👗', 'dress', 'dress'],
      ['👘', 'kimono', 'kimono'],
      ['🥻', 'sari', 'sari'],
      ['🩱', 'one-piece swimsuit', 'one_piece_swimsuit'],
      ['🩲', 'briefs', 'swim_brief'],
      ['🩳', 'shorts', 'shorts'],
      ['👙', 'bikini', 'bikini'],
      ['👚', 'woman’s clothes', 'womans_clothes'],
      ['👛', 'purse', 'purse'],
      ['👜', 'handbag', 'handbag'],
      ['👝', 'clutch bag', 'pouch'],
      ['🛍️', 'shopping bags'],
      ['🎒', 'backpack', 'school_satchel'],
      ['🩴', 'thong sandal'],
      ['👞', 'man’s shoe', 'mans_shoe,shoe'],
      ['👟', 'running shoe', 'athletic_shoe'],
      ['🥾', 'hiking boot', 'hiking_boot'],
      ['🥿', 'flat shoe', 'flat_shoe'],
      ['👠', 'high-heeled shoe', 'high_heel'],
      ['👡', 'woman’s sandal', 'sandal'],
      ['🩰', 'ballet shoes', 'ballet_shoes'],
      ['👢', 'woman’s boot', 'boot'],
      ['👑', 'crown', 'crown'],
      ['👒', 'woman’s hat', 'womans_hat'],
      ['🎩', 'top hat', 'tophat'],
      ['🎓', 'graduation cap', 'mortar_board'],
      ['🧢', 'billed cap', 'billed_cap'],
      ['🪖', 'military helmet'],
      ['⛑️', 'rescue worker’s helmet'],
      ['📿', 'prayer beads', 'prayer_beads'],
      ['💄', 'lipstick', 'lipstick'],
      ['💍', 'ring', 'ring'],
      ['💎', 'gem stone', 'gem'],
      ['🔇', 'muted speaker', 'mute'],
      ['🔈', 'speaker low volume', 'speaker'],
      ['🔉', 'speaker medium volume', 'sound'],
      ['🔊', 'speaker high volume', 'loud_sound'],
      ['📢', 'loudspeaker', 'loudspeaker'],
      ['📣', 'megaphone', 'mega'],
      ['📯', 'postal horn', 'postal_horn'],
      ['🔔', 'bell', 'bell'],
      ['🔕', 'bell with slash', 'no_bell'],
      ['🎼', 'musical score', 'musical_score'],
      ['🎵', 'musical note', 'musical_note'],
      ['🎶', 'musical notes', 'notes'],
      ['🎙️', 'studio microphone'],
      ['🎚️', 'level slider'],
      ['🎛️', 'control knobs'],
      ['🎤', 'microphone', 'microphone'],
      ['🎧', 'headphone', 'headphones'],
      ['📻', 'radio', 'radio'],
      ['🎷', 'saxophone', 'saxophone'],
      ['🪗', 'accordion'],
      ['🎸', 'guitar', 'guitar'],
      ['🎹', 'musical keyboard', 'musical_keyboard'],
      ['🎺', 'trumpet', 'trumpet'],
      ['🎻', 'violin', 'violin'],
      ['🪕', 'banjo', 'banjo'],
      ['🥁', 'drum', 'drum'],
      ['🪘', 'long drum'],
      ['📱', 'mobile phone', 'iphone'],
      ['📲', 'mobile phone with arrow', 'calling'],
      ['☎️', 'telephone'],
      ['📞', 'telephone receiver', 'telephone_receiver'],
      ['📟', 'pager', 'pager'],
      ['📠', 'fax machine', 'fax'],
      ['🔋', 'battery', 'battery'],
      ['🔌', 'electric plug', 'electric_plug'],
      ['💻', 'laptop', 'computer'],
      ['🖥️', 'desktop computer'],
      ['🖨️', 'printer'],
      ['⌨️', 'keyboard'],
      ['🖱️', 'computer mouse'],
      ['🖲️', 'trackball'],
      ['💽', 'computer disk', 'minidisc'],
      ['💾', 'floppy disk', 'floppy_disk'],
      ['💿', 'optical disk', 'cd'],
      ['📀', 'dvd', 'dvd'],
      ['🧮', 'abacus', 'abacus'],
      ['🎥', 'movie camera', 'movie_camera'],
      ['🎞️', 'film frames'],
      ['📽️', 'film projector'],
      ['🎬', 'clapper board', 'clapper'],
      ['📺', 'television', 'tv'],
      ['📷', 'camera', 'camera'],
      ['📸', 'camera with flash', 'camera_flash'],
      ['📹', 'video camera', 'video_camera'],
      ['📼', 'videocassette', 'vhs'],
      ['🔍', 'magnifying glass tilted left', 'mag'],
      ['🔎', 'magnifying glass tilted right', 'mag_right'],
      ['🕯️', 'candle'],
      ['💡', 'light bulb', 'bulb'],
      ['🔦', 'flashlight', 'flashlight'],
      ['🏮', 'red paper lantern', 'izakaya_lantern,lantern'],
      ['🪔', 'diya lamp', 'diya_lamp'],
      [
        '📔',
        'notebook with decorative cover',
        'notebook_with_decorative_cover'
      ],
      ['📕', 'closed book', 'closed_book'],
      ['📖', 'open book', 'book,open_book'],
      ['📗', 'green book', 'green_book'],
      ['📘', 'blue book', 'blue_book'],
      ['📙', 'orange book', 'orange_book'],
      ['📚', 'books', 'books'],
      ['📓', 'notebook', 'notebook'],
      ['📒', 'ledger', 'ledger'],
      ['📃', 'page with curl', 'page_with_curl'],
      ['📜', 'scroll', 'scroll'],
      ['📄', 'page facing up', 'page_facing_up'],
      ['📰', 'newspaper', 'newspaper'],
      ['🗞️', 'rolled-up newspaper'],
      ['📑', 'bookmark tabs', 'bookmark_tabs'],
      ['🔖', 'bookmark', 'bookmark'],
      ['🏷️', 'label'],
      ['💰', 'money bag', 'moneybag'],
      ['🪙', 'coin'],
      ['💴', 'yen banknote', 'yen'],
      ['💵', 'dollar banknote', 'dollar'],
      ['💶', 'euro banknote', 'euro'],
      ['💷', 'pound banknote', 'pound'],
      ['💸', 'money with wings', 'money_with_wings'],
      ['💳', 'credit card', 'credit_card'],
      ['🧾', 'receipt', 'receipt'],
      ['💹', 'chart increasing with yen', 'chart'],
      ['✉️', 'envelope'],
      ['📧', 'e-mail', 'e-mail'],
      ['📨', 'incoming envelope', 'incoming_envelope'],
      ['📩', 'envelope with arrow', 'envelope_with_arrow'],
      ['📤', 'outbox tray', 'outbox_tray'],
      ['📥', 'inbox tray', 'inbox_tray'],
      ['📦', 'package', 'package'],
      ['📫', 'closed mailbox with raised flag', 'mailbox'],
      ['📪', 'closed mailbox with lowered flag', 'mailbox_closed'],
      ['📬', 'open mailbox with raised flag', 'mailbox_with_mail'],
      ['📭', 'open mailbox with lowered flag', 'mailbox_with_no_mail'],
      ['📮', 'postbox', 'postbox'],
      ['🗳️', 'ballot box with ballot'],
      ['✏️', 'pencil'],
      ['✒️', 'black nib'],
      ['🖋️', 'fountain pen'],
      ['🖊️', 'pen'],
      ['🖌️', 'paintbrush'],
      ['🖍️', 'crayon'],
      ['📝', 'memo', 'memo,pencil'],
      ['💼', 'briefcase', 'briefcase'],
      ['📁', 'file folder', 'file_folder'],
      ['📂', 'open file folder', 'open_file_folder'],
      ['🗂️', 'card index dividers'],
      ['📅', 'calendar', 'date'],
      ['📆', 'tear-off calendar', 'calendar'],
      ['🗒️', 'spiral notepad'],
      ['🗓️', 'spiral calendar'],
      ['📇', 'card index', 'card_index'],
      ['📈', 'chart increasing', 'chart_with_upwards_trend'],
      ['📉', 'chart decreasing', 'chart_with_downwards_trend'],
      ['📊', 'bar chart', 'bar_chart'],
      ['📋', 'clipboard', 'clipboard'],
      ['📌', 'pushpin', 'pushpin'],
      ['📍', 'round pushpin', 'round_pushpin'],
      ['📎', 'paperclip', 'paperclip'],
      ['🖇️', 'linked paperclips'],
      ['📏', 'straight ruler', 'straight_ruler'],
      ['📐', 'triangular ruler', 'triangular_ruler'],
      ['✂️', 'scissors'],
      ['🗃️', 'card file box'],
      ['🗄️', 'file cabinet'],
      ['🗑️', 'wastebasket'],
      ['🔒', 'locked', 'lock'],
      ['🔓', 'unlocked', 'unlock'],
      ['🔏', 'locked with pen', 'lock_with_ink_pen'],
      ['🔐', 'locked with key', 'closed_lock_with_key'],
      ['🔑', 'key', 'key'],
      ['🗝️', 'old key'],
      ['🔨', 'hammer', 'hammer'],
      ['🪓', 'axe', 'axe'],
      ['⛏️', 'pick'],
      ['⚒️', 'hammer and pick'],
      ['🛠️', 'hammer and wrench'],
      ['🗡️', 'dagger'],
      ['⚔️', 'crossed swords'],
      ['🔫', 'water pistol', 'gun'],
      ['🪃', 'boomerang'],
      ['🏹', 'bow and arrow', 'bow_and_arrow'],
      ['🛡️', 'shield'],
      ['🪚', 'carpentry saw'],
      ['🔧', 'wrench', 'wrench'],
      ['🪛', 'screwdriver'],
      ['🔩', 'nut and bolt', 'nut_and_bolt'],
      ['⚙️', 'gear'],
      ['🗜️', 'clamp'],
      ['⚖️', 'balance scale'],
      ['🦯', 'white cane', 'probing_cane'],
      ['🔗', 'link', 'link'],
      ['⛓️', 'chains'],
      ['🪝', 'hook'],
      ['🧰', 'toolbox', 'toolbox'],
      ['🧲', 'magnet', 'magnet'],
      ['🪜', 'ladder'],
      ['⚗️', 'alembic'],
      ['🧪', 'test tube', 'test_tube'],
      ['🧫', 'petri dish', 'petri_dish'],
      ['🧬', 'dna', 'dna'],
      ['🔬', 'microscope', 'microscope'],
      ['🔭', 'telescope', 'telescope'],
      ['📡', 'satellite antenna', 'satellite'],
      ['💉', 'syringe', 'syringe'],
      ['🩸', 'drop of blood', 'drop_of_blood'],
      ['💊', 'pill', 'pill'],
      ['🩹', 'adhesive bandage', 'adhesive_bandage'],
      ['🩺', 'stethoscope', 'stethoscope'],
      ['🚪', 'door', 'door'],
      ['🛗', 'elevator'],
      ['🪞', 'mirror'],
      ['🪟', 'window'],
      ['🛏️', 'bed'],
      ['🛋️', 'couch and lamp'],
      ['🪑', 'chair', 'chair'],
      ['🚽', 'toilet', 'toilet'],
      ['🪠', 'plunger'],
      ['🚿', 'shower', 'shower'],
      ['🛁', 'bathtub', 'bathtub'],
      ['🪤', 'mouse trap'],
      ['🪒', 'razor', 'razor'],
      ['🧴', 'lotion bottle', 'lotion_bottle'],
      ['🧷', 'safety pin', 'safety_pin'],
      ['🧹', 'broom', 'broom'],
      ['🧺', 'basket', 'basket'],
      ['🧻', 'roll of paper', 'roll_of_paper'],
      ['🪣', 'bucket'],
      ['🧼', 'soap', 'soap'],
      ['🪥', 'toothbrush'],
      ['🧽', 'sponge', 'sponge'],
      ['🧯', 'fire extinguisher', 'fire_extinguisher'],
      ['🛒', 'shopping cart', 'shopping_cart'],
      ['🚬', 'cigarette', 'smoking'],
      ['⚰️', 'coffin'],
      ['🪦', 'headstone'],
      ['⚱️', 'funeral urn'],
      ['🗿', 'moai', 'moyai'],
      ['🪧', 'placard']
    ]
  },
  {
    category: 'Symbols',
    emojis: [
      ['🏧', 'ATM sign', 'atm'],
      ['🚮', 'litter in bin sign', 'put_litter_in_its_place'],
      ['🚰', 'potable water', 'potable_water'],
      ['♿', 'wheelchair symbol', 'wheelchair'],
      ['🚹', 'men’s room', 'mens'],
      ['🚺', 'women’s room', 'womens'],
      ['🚻', 'restroom', 'restroom'],
      ['🚼', 'baby symbol', 'baby_symbol'],
      ['🚾', 'water closet', 'wc'],
      ['🛂', 'passport control', 'passport_control'],
      ['🛃', 'customs', 'customs'],
      ['🛄', 'baggage claim', 'baggage_claim'],
      ['🛅', 'left luggage', 'left_luggage'],
      ['⚠️', 'warning'],
      ['🚸', 'children crossing', 'children_crossing'],
      ['⛔', 'no entry', 'no_entry'],
      ['🚫', 'prohibited', 'no_entry_sign'],
      ['🚳', 'no bicycles', 'no_bicycles'],
      ['🚭', 'no smoking', 'no_smoking'],
      ['🚯', 'no littering', 'do_not_litter'],
      ['🚱', 'non-potable water', 'non-potable_water'],
      ['🚷', 'no pedestrians', 'no_pedestrians'],
      ['📵', 'no mobile phones', 'no_mobile_phones'],
      ['🔞', 'no one under eighteen', 'underage'],
      ['☢️', 'radioactive'],
      ['☣️', 'biohazard'],
      ['⬆️', 'up arrow'],
      ['↗️', 'up-right arrow'],
      ['➡️', 'right arrow'],
      ['↘️', 'down-right arrow'],
      ['⬇️', 'down arrow'],
      ['↙️', 'down-left arrow'],
      ['⬅️', 'left arrow'],
      ['↖️', 'up-left arrow'],
      ['↕️', 'up-down arrow'],
      ['↔️', 'left-right arrow'],
      ['↩️', 'right arrow curving left'],
      ['↪️', 'left arrow curving right'],
      ['⤴️', 'right arrow curving up'],
      ['⤵️', 'right arrow curving down'],
      ['🔃', 'clockwise vertical arrows', 'arrows_clockwise'],
      ['🔄', 'counterclockwise arrows button', 'arrows_counterclockwise'],
      ['🔙', 'BACK arrow', 'back'],
      ['🔚', 'END arrow', 'end'],
      ['🔛', 'ON! arrow', 'on'],
      ['🔜', 'SOON arrow', 'soon'],
      ['🔝', 'TOP arrow', 'top'],
      ['🛐', 'place of worship', 'place_of_worship'],
      ['⚛️', 'atom symbol'],
      ['🕉️', 'om'],
      ['✡️', 'star of David'],
      ['☸️', 'wheel of dharma'],
      ['☯️', 'yin yang'],
      ['✝️', 'latin cross'],
      ['☦️', 'orthodox cross'],
      ['☪️', 'star and crescent'],
      ['☮️', 'peace symbol'],
      ['🕎', 'menorah', 'menorah'],
      ['🔯', 'dotted six-pointed star', 'six_pointed_star'],
      ['♈', 'Aries', 'aries'],
      ['♉', 'Taurus', 'taurus'],
      ['♊', 'Gemini', 'gemini'],
      ['♋', 'Cancer', 'cancer'],
      ['♌', 'Leo', 'leo'],
      ['♍', 'Virgo', 'virgo'],
      ['♎', 'Libra', 'libra'],
      ['♏', 'Scorpio', 'scorpius'],
      ['♐', 'Sagittarius', 'sagittarius'],
      ['♑', 'Capricorn', 'capricorn'],
      ['♒', 'Aquarius', 'aquarius'],
      ['♓', 'Pisces', 'pisces'],
      ['⛎', 'Ophiuchus', 'ophiuchus'],
      ['🔀', 'shuffle tracks button', 'twisted_rightwards_arrows'],
      ['🔁', 'repeat button', 'repeat'],
      ['🔂', 'repeat single button', 'repeat_one'],
      ['▶️', 'play button'],
      ['⏩', 'fast-forward button', 'fast_forward'],
      ['⏭️', 'next track button'],
      ['⏯️', 'play or pause button'],
      ['◀️', 'reverse button'],
      ['⏪', 'fast reverse button', 'rewind'],
      ['⏮️', 'last track button'],
      ['🔼', 'upwards button', 'arrow_up_small'],
      ['⏫', 'fast up button', 'arrow_double_up'],
      ['🔽', 'downwards button', 'arrow_down_small'],
      ['⏬', 'fast down button', 'arrow_double_down'],
      ['⏸️', 'pause button'],
      ['⏹️', 'stop button'],
      ['⏺️', 'record button'],
      ['⏏️', 'eject button'],
      ['🎦', 'cinema', 'cinema'],
      ['🔅', 'dim button', 'low_brightness'],
      ['🔆', 'bright button', 'high_brightness'],
      ['📶', 'antenna bars', 'signal_strength'],
      ['📳', 'vibration mode', 'vibration_mode'],
      ['📴', 'mobile phone off', 'mobile_phone_off'],
      ['♀️', 'female sign'],
      ['♂️', 'male sign'],
      ['⚧️', 'transgender symbol'],
      ['✖️', 'multiply'],
      ['➕', 'plus', 'heavy_plus_sign'],
      ['➖', 'minus', 'heavy_minus_sign'],
      ['➗', 'divide', 'heavy_division_sign'],
      ['♾️', 'infinity'],
      ['‼️', 'double exclamation mark'],
      ['⁉️', 'exclamation question mark'],
      ['❓', 'red question mark', 'question'],
      ['❔', 'white question mark', 'grey_question'],
      ['❕', 'white exclamation mark', 'grey_exclamation'],
      ['❗', 'red exclamation mark', 'exclamation,heavy_exclamation_mark'],
      ['〰️', 'wavy dash'],
      ['💱', 'currency exchange', 'currency_exchange'],
      ['💲', 'heavy dollar sign', 'heavy_dollar_sign'],
      ['⚕️', 'medical symbol'],
      ['♻️', 'recycling symbol'],
      ['⚜️', 'fleur-de-lis'],
      ['🔱', 'trident emblem', 'trident'],
      ['📛', 'name badge', 'name_badge'],
      ['🔰', 'Japanese symbol for beginner', 'beginner'],
      ['⭕', 'hollow red circle', 'o'],
      ['✅', 'check mark button', 'white_check_mark'],
      ['☑️', 'check box with check'],
      ['✔️', 'check mark'],
      ['❌', 'cross mark', 'x'],
      ['❎', 'cross mark button', 'negative_squared_cross_mark'],
      ['➰', 'curly loop', 'curly_loop'],
      ['➿', 'double curly loop', 'loop'],
      ['〽️', 'part alternation mark'],
      ['✳️', 'eight-spoked asterisk'],
      ['✴️', 'eight-pointed star'],
      ['❇️', 'sparkle'],
      ['©️', 'copyright'],
      ['®️', 'registered'],
      ['™️', 'trade mark'],
      ['#️⃣', 'keycap: #'],
      ['*️⃣', 'keycap: *'],
      ['0️⃣', 'keycap: 0'],
      ['1️⃣', 'keycap: 1'],
      ['2️⃣', 'keycap: 2'],
      ['3️⃣', 'keycap: 3'],
      ['4️⃣', 'keycap: 4'],
      ['5️⃣', 'keycap: 5'],
      ['6️⃣', 'keycap: 6'],
      ['7️⃣', 'keycap: 7'],
      ['8️⃣', 'keycap: 8'],
      ['9️⃣', 'keycap: 9'],
      ['🔟', 'keycap: 10', 'keycap_ten'],
      ['🔠', 'input latin uppercase', 'capital_abcd'],
      ['🔡', 'input latin lowercase', 'abcd'],
      ['🔢', 'input numbers', '1234'],
      ['🔣', 'input symbols', 'symbols'],
      ['🔤', 'input latin letters', 'abc'],
      ['🅰️', 'A button (blood type)'],
      ['🆎', 'AB button (blood type)', 'ab'],
      ['🅱️', 'B button (blood type)'],
      ['🆑', 'CL button', 'cl'],
      ['🆒', 'COOL button', 'cool'],
      ['🆓', 'FREE button', 'free'],
      ['ℹ️', 'information'],
      ['🆔', 'ID button', 'id'],
      ['Ⓜ️', 'circled M'],
      ['🆕', 'NEW button', 'new'],
      ['🆖', 'NG button', 'ng'],
      ['🅾️', 'O button (blood type)'],
      ['🆗', 'OK button', 'ok'],
      ['🅿️', 'P button'],
      ['🆘', 'SOS button', 'sos'],
      ['🆙', 'UP! button', 'up'],
      ['🆚', 'VS button', 'vs'],
      ['🈁', 'Japanese “here” button', 'koko'],
      ['🈂️', 'Japanese “service charge” button'],
      ['🈷️', 'Japanese “monthly amount” button'],
      ['🈶', 'Japanese “not free of charge” button', 'u6709'],
      ['🈯', 'Japanese “reserved” button', 'u6307'],
      ['🉐', 'Japanese “bargain” button', 'ideograph_advantage'],
      ['🈹', 'Japanese “discount” button', 'u5272'],
      ['🈚', 'Japanese “free of charge” button', 'u7121'],
      ['🈲', 'Japanese “prohibited” button', 'u7981'],
      ['🉑', 'Japanese “acceptable” button', 'accept'],
      ['🈸', 'Japanese “application” button', 'u7533'],
      ['🈴', 'Japanese “passing grade” button', 'u5408'],
      ['🈳', 'Japanese “vacancy” button', 'u7a7a'],
      ['㊗️', 'Japanese “congratulations” button'],
      ['㊙️', 'Japanese “secret” button'],
      ['🈺', 'Japanese “open for business” button', 'u55b6'],
      ['🈵', 'Japanese “no vacancy” button', 'u6e80'],
      ['🔴', 'red circle', 'red_circle'],
      ['🟠', 'orange circle', 'orange_circle'],
      ['🟡', 'yellow circle', 'yellow_circle'],
      ['🟢', 'green circle', 'green_circle'],
      ['🔵', 'blue circle', 'large_blue_circle'],
      ['🟣', 'purple circle', 'purple_circle'],
      ['🟤', 'brown circle', 'brown_circle'],
      ['⚫', 'black circle', 'black_circle'],
      ['⚪', 'white circle', 'white_circle'],
      ['🟥', 'red square', 'red_square'],
      ['🟧', 'orange square', 'orange_square'],
      ['🟨', 'yellow square', 'yellow_square'],
      ['🟩', 'green square', 'green_square'],
      ['🟦', 'blue square', 'blue_square'],
      ['🟪', 'purple square', 'purple_square'],
      ['🟫', 'brown square', 'brown_square'],
      ['⬛', 'black large square', 'black_large_square'],
      ['⬜', 'white large square', 'white_large_square'],
      ['◼️', 'black medium square'],
      ['◻️', 'white medium square'],
      ['◾', 'black medium-small square', 'black_medium_small_square'],
      ['◽', 'white medium-small square', 'white_medium_small_square'],
      ['▪️', 'black small square'],
      ['▫️', 'white small square'],
      ['🔶', 'large orange diamond', 'large_orange_diamond'],
      ['🔷', 'large blue diamond', 'large_blue_diamond'],
      ['🔸', 'small orange diamond', 'small_orange_diamond'],
      ['🔹', 'small blue diamond', 'small_blue_diamond'],
      ['🔺', 'red triangle pointed up', 'small_red_triangle'],
      ['🔻', 'red triangle pointed down', 'small_red_triangle_down'],
      ['💠', 'diamond with a dot', 'diamond_shape_with_a_dot_inside'],
      ['🔘', 'radio button', 'radio_button'],
      ['🔳', 'white square button', 'white_square_button'],
      ['🔲', 'black square button', 'black_square_button']
    ]
  },
  {
    category: 'Flags',
    emojis: [
      ['🏁', 'chequered flag', 'checkered_flag'],
      ['🚩', 'triangular flag', 'triangular_flag_on_post'],
      ['🎌', 'crossed flags', 'crossed_flags'],
      ['🏴', 'black flag', 'black_flag'],
      ['🏳️', 'white flag'],
      ['🏳️‍🌈', 'rainbow flag'],
      ['🏳️‍⚧️', 'transgender flag'],
      ['🏴‍☠️', 'pirate flag'],
      ['🇦🇨', 'flag: Ascension Island'],
      ['🇦🇩', 'flag: Andorra'],
      ['🇦🇪', 'flag: United Arab Emirates'],
      ['🇦🇫', 'flag: Afghanistan'],
      ['🇦🇬', 'flag: Antigua & Barbuda'],
      ['🇦🇮', 'flag: Anguilla'],
      ['🇦🇱', 'flag: Albania'],
      ['🇦🇲', 'flag: Armenia'],
      ['🇦🇴', 'flag: Angola'],
      ['🇦🇶', 'flag: Antarctica'],
      ['🇦🇷', 'flag: Argentina'],
      ['🇦🇸', 'flag: American Samoa'],
      ['🇦🇹', 'flag: Austria'],
      ['🇦🇺', 'flag: Australia'],
      ['🇦🇼', 'flag: Aruba'],
      ['🇦🇽', 'flag: Åland Islands'],
      ['🇦🇿', 'flag: Azerbaijan'],
      ['🇧🇦', 'flag: Bosnia & Herzegovina'],
      ['🇧🇧', 'flag: Barbados'],
      ['🇧🇩', 'flag: Bangladesh'],
      ['🇧🇪', 'flag: Belgium'],
      ['🇧🇫', 'flag: Burkina Faso'],
      ['🇧🇬', 'flag: Bulgaria'],
      ['🇧🇭', 'flag: Bahrain'],
      ['🇧🇮', 'flag: Burundi'],
      ['🇧🇯', 'flag: Benin'],
      ['🇧🇱', 'flag: St. Barthélemy'],
      ['🇧🇲', 'flag: Bermuda'],
      ['🇧🇳', 'flag: Brunei'],
      ['🇧🇴', 'flag: Bolivia'],
      ['🇧🇶', 'flag: Caribbean Netherlands'],
      ['🇧🇷', 'flag: Brazil'],
      ['🇧🇸', 'flag: Bahamas'],
      ['🇧🇹', 'flag: Bhutan'],
      ['🇧🇻', 'flag: Bouvet Island'],
      ['🇧🇼', 'flag: Botswana'],
      ['🇧🇾', 'flag: Belarus'],
      ['🇧🇿', 'flag: Belize'],
      ['🇨🇦', 'flag: Canada'],
      ['🇨🇨', 'flag: Cocos (Keeling) Islands'],
      ['🇨🇩', 'flag: Congo - Kinshasa'],
      ['🇨🇫', 'flag: Central African Republic'],
      ['🇨🇬', 'flag: Congo - Brazzaville'],
      ['🇨🇭', 'flag: Switzerland'],
      ['🇨🇮', 'flag: Côte d’Ivoire'],
      ['🇨🇰', 'flag: Cook Islands'],
      ['🇨🇱', 'flag: Chile'],
      ['🇨🇲', 'flag: Cameroon'],
      ['🇨🇳', 'flag: China'],
      ['🇨🇴', 'flag: Colombia'],
      ['🇨🇵', 'flag: Clipperton Island'],
      ['🇨🇷', 'flag: Costa Rica'],
      ['🇨🇺', 'flag: Cuba'],
      ['🇨🇻', 'flag: Cape Verde'],
      ['🇨🇼', 'flag: Curaçao'],
      ['🇨🇽', 'flag: Christmas Island'],
      ['🇨🇾', 'flag: Cyprus'],
      ['🇨🇿', 'flag: Czechia'],
      ['🇩🇪', 'flag: Germany'],
      ['🇩🇬', 'flag: Diego Garcia'],
      ['🇩🇯', 'flag: Djibouti'],
      ['🇩🇰', 'flag: Denmark'],
      ['🇩🇲', 'flag: Dominica'],
      ['🇩🇴', 'flag: Dominican Republic'],
      ['🇩🇿', 'flag: Algeria'],
      ['🇪🇦', 'flag: Ceuta & Melilla'],
      ['🇪🇨', 'flag: Ecuador'],
      ['🇪🇪', 'flag: Estonia'],
      ['🇪🇬', 'flag: Egypt'],
      ['🇪🇭', 'flag: Western Sahara'],
      ['🇪🇷', 'flag: Eritrea'],
      ['🇪🇸', 'flag: Spain'],
      ['🇪🇹', 'flag: Ethiopia'],
      ['🇪🇺', 'flag: European Union'],
      ['🇫🇮', 'flag: Finland'],
      ['🇫🇯', 'flag: Fiji'],
      ['🇫🇰', 'flag: Falkland Islands'],
      ['🇫🇲', 'flag: Micronesia'],
      ['🇫🇴', 'flag: Faroe Islands'],
      ['🇫🇷', 'flag: France'],
      ['🇬🇦', 'flag: Gabon'],
      ['🇬🇧', 'flag: United Kingdom'],
      ['🇬🇩', 'flag: Grenada'],
      ['🇬🇪', 'flag: Georgia'],
      ['🇬🇫', 'flag: French Guiana'],
      ['🇬🇬', 'flag: Guernsey'],
      ['🇬🇭', 'flag: Ghana'],
      ['🇬🇮', 'flag: Gibraltar'],
      ['🇬🇱', 'flag: Greenland'],
      ['🇬🇲', 'flag: Gambia'],
      ['🇬🇳', 'flag: Guinea'],
      ['🇬🇵', 'flag: Guadeloupe'],
      ['🇬🇶', 'flag: Equatorial Guinea'],
      ['🇬🇷', 'flag: Greece'],
      ['🇬🇸', 'flag: South Georgia & South Sandwich Islands'],
      ['🇬🇹', 'flag: Guatemala'],
      ['🇬🇺', 'flag: Guam'],
      ['🇬🇼', 'flag: Guinea-Bissau'],
      ['🇬🇾', 'flag: Guyana'],
      ['🇭🇰', 'flag: Hong Kong SAR China'],
      ['🇭🇲', 'flag: Heard & McDonald Islands'],
      ['🇭🇳', 'flag: Honduras'],
      ['🇭🇷', 'flag: Croatia'],
      ['🇭🇹', 'flag: Haiti'],
      ['🇭🇺', 'flag: Hungary'],
      ['🇮🇨', 'flag: Canary Islands'],
      ['🇮🇩', 'flag: Indonesia'],
      ['🇮🇪', 'flag: Ireland'],
      ['🇮🇱', 'flag: Israel'],
      ['🇮🇲', 'flag: Isle of Man'],
      ['🇮🇳', 'flag: India'],
      ['🇮🇴', 'flag: British Indian Ocean Territory'],
      ['🇮🇶', 'flag: Iraq'],
      ['🇮🇷', 'flag: Iran'],
      ['🇮🇸', 'flag: Iceland'],
      ['🇮🇹', 'flag: Italy'],
      ['🇯🇪', 'flag: Jersey'],
      ['🇯🇲', 'flag: Jamaica'],
      ['🇯🇴', 'flag: Jordan'],
      ['🇯🇵', 'flag: Japan'],
      ['🇰🇪', 'flag: Kenya'],
      ['🇰🇬', 'flag: Kyrgyzstan'],
      ['🇰🇭', 'flag: Cambodia'],
      ['🇰🇮', 'flag: Kiribati'],
      ['🇰🇲', 'flag: Comoros'],
      ['🇰🇳', 'flag: St. Kitts & Nevis'],
      ['🇰🇵', 'flag: North Korea'],
      ['🇰🇷', 'flag: South Korea'],
      ['🇰🇼', 'flag: Kuwait'],
      ['🇰🇾', 'flag: Cayman Islands'],
      ['🇰🇿', 'flag: Kazakhstan'],
      ['🇱🇦', 'flag: Laos'],
      ['🇱🇧', 'flag: Lebanon'],
      ['🇱🇨', 'flag: St. Lucia'],
      ['🇱🇮', 'flag: Liechtenstein'],
      ['🇱🇰', 'flag: Sri Lanka'],
      ['🇱🇷', 'flag: Liberia'],
      ['🇱🇸', 'flag: Lesotho'],
      ['🇱🇹', 'flag: Lithuania'],
      ['🇱🇺', 'flag: Luxembourg'],
      ['🇱🇻', 'flag: Latvia'],
      ['🇱🇾', 'flag: Libya'],
      ['🇲🇦', 'flag: Morocco'],
      ['🇲🇨', 'flag: Monaco'],
      ['🇲🇩', 'flag: Moldova'],
      ['🇲🇪', 'flag: Montenegro'],
      ['🇲🇫', 'flag: St. Martin'],
      ['🇲🇬', 'flag: Madagascar'],
      ['🇲🇭', 'flag: Marshall Islands'],
      ['🇲🇰', 'flag: North Macedonia'],
      ['🇲🇱', 'flag: Mali'],
      ['🇲🇲', 'flag: Myanmar (Burma)'],
      ['🇲🇳', 'flag: Mongolia'],
      ['🇲🇴', 'flag: Macao SAR China'],
      ['🇲🇵', 'flag: Northern Mariana Islands'],
      ['🇲🇶', 'flag: Martinique'],
      ['🇲🇷', 'flag: Mauritania'],
      ['🇲🇸', 'flag: Montserrat'],
      ['🇲🇹', 'flag: Malta'],
      ['🇲🇺', 'flag: Mauritius'],
      ['🇲🇻', 'flag: Maldives'],
      ['🇲🇼', 'flag: Malawi'],
      ['🇲🇽', 'flag: Mexico'],
      ['🇲🇾', 'flag: Malaysia'],
      ['🇲🇿', 'flag: Mozambique'],
      ['🇳🇦', 'flag: Namibia'],
      ['🇳🇨', 'flag: New Caledonia'],
      ['🇳🇪', 'flag: Niger'],
      ['🇳🇫', 'flag: Norfolk Island'],
      ['🇳🇬', 'flag: Nigeria'],
      ['🇳🇮', 'flag: Nicaragua'],
      ['🇳🇱', 'flag: Netherlands'],
      ['🇳🇴', 'flag: Norway'],
      ['🇳🇵', 'flag: Nepal'],
      ['🇳🇷', 'flag: Nauru'],
      ['🇳🇺', 'flag: Niue'],
      ['🇳🇿', 'flag: New Zealand'],
      ['🇴🇲', 'flag: Oman'],
      ['🇵🇦', 'flag: Panama'],
      ['🇵🇪', 'flag: Peru'],
      ['🇵🇫', 'flag: French Polynesia'],
      ['🇵🇬', 'flag: Papua New Guinea'],
      ['🇵🇭', 'flag: Philippines'],
      ['🇵🇰', 'flag: Pakistan'],
      ['🇵🇱', 'flag: Poland'],
      ['🇵🇲', 'flag: St. Pierre & Miquelon'],
      ['🇵🇳', 'flag: Pitcairn Islands'],
      ['🇵🇷', 'flag: Puerto Rico'],
      ['🇵🇸', 'flag: Palestinian Territories'],
      ['🇵🇹', 'flag: Portugal'],
      ['🇵🇼', 'flag: Palau'],
      ['🇵🇾', 'flag: Paraguay'],
      ['🇶🇦', 'flag: Qatar'],
      ['🇷🇪', 'flag: Réunion'],
      ['🇷🇴', 'flag: Romania'],
      ['🇷🇸', 'flag: Serbia'],
      ['🇷🇺', 'flag: Russia'],
      ['🇷🇼', 'flag: Rwanda'],
      ['🇸🇦', 'flag: Saudi Arabia'],
      ['🇸🇧', 'flag: Solomon Islands'],
      ['🇸🇨', 'flag: Seychelles'],
      ['🇸🇩', 'flag: Sudan'],
      ['🇸🇪', 'flag: Sweden'],
      ['🇸🇬', 'flag: Singapore'],
      ['🇸🇭', 'flag: St. Helena'],
      ['🇸🇮', 'flag: Slovenia'],
      ['🇸🇯', 'flag: Svalbard & Jan Mayen'],
      ['🇸🇰', 'flag: Slovakia'],
      ['🇸🇱', 'flag: Sierra Leone'],
      ['🇸🇲', 'flag: San Marino'],
      ['🇸🇳', 'flag: Senegal'],
      ['🇸🇴', 'flag: Somalia'],
      ['🇸🇷', 'flag: Suriname'],
      ['🇸🇸', 'flag: South Sudan'],
      ['🇸🇹', 'flag: São Tomé & Príncipe'],
      ['🇸🇻', 'flag: El Salvador'],
      ['🇸🇽', 'flag: Sint Maarten'],
      ['🇸🇾', 'flag: Syria'],
      ['🇸🇿', 'flag: Eswatini'],
      ['🇹🇦', 'flag: Tristan da Cunha'],
      ['🇹🇨', 'flag: Turks & Caicos Islands'],
      ['🇹🇩', 'flag: Chad'],
      ['🇹🇫', 'flag: French Southern Territories'],
      ['🇹🇬', 'flag: Togo'],
      ['🇹🇭', 'flag: Thailand'],
      ['🇹🇯', 'flag: Tajikistan'],
      ['🇹🇰', 'flag: Tokelau'],
      ['🇹🇱', 'flag: Timor-Leste'],
      ['🇹🇲', 'flag: Turkmenistan'],
      ['🇹🇳', 'flag: Tunisia'],
      ['🇹🇴', 'flag: Tonga'],
      ['🇹🇷', 'flag: Turkey'],
      ['🇹🇹', 'flag: Trinidad & Tobago'],
      ['🇹🇻', 'flag: Tuvalu'],
      ['🇹🇼', 'flag: Taiwan'],
      ['🇹🇿', 'flag: Tanzania'],
      ['🇺🇦', 'flag: Ukraine'],
      ['🇺🇬', 'flag: Uganda'],
      ['🇺🇲', 'flag: U.S. Outlying Islands'],
      ['🇺🇳', 'flag: United Nations'],
      ['🇺🇸', 'flag: United States'],
      ['🇺🇾', 'flag: Uruguay'],
      ['🇺🇿', 'flag: Uzbekistan'],
      ['🇻🇦', 'flag: Vatican City'],
      ['🇻🇨', 'flag: St. Vincent & Grenadines'],
      ['🇻🇪', 'flag: Venezuela'],
      ['🇻🇬', 'flag: British Virgin Islands'],
      ['🇻🇮', 'flag: U.S. Virgin Islands'],
      ['🇻🇳', 'flag: Vietnam'],
      ['🇻🇺', 'flag: Vanuatu'],
      ['🇼🇫', 'flag: Wallis & Futuna'],
      ['🇼🇸', 'flag: Samoa'],
      ['🇽🇰', 'flag: Kosovo'],
      ['🇾🇪', 'flag: Yemen'],
      ['🇾🇹', 'flag: Mayotte'],
      ['🇿🇦', 'flag: South Africa'],
      ['🇿🇲', 'flag: Zambia'],
      ['🇿🇼', 'flag: Zimbabwe'],
      ['🏴󠁧󠁢󠁥󠁮󠁧󠁿', 'flag: England'],
      ['🏴󠁧󠁢󠁳󠁣󠁴󠁿', 'flag: Scotland'],
      ['🏴󠁧󠁢󠁷󠁬󠁳󠁿', 'flag: Wales']
    ]
  }
];
